{
  "addons.addonList": "Seznam doplňků",
  "addons.ambientWeatherCreateAndRetrieveApiKey": "Vytvořte a získejte klíč API z tohoto odkazu",
  "addons.ambientWeatherDescription": "Ambientní meteorologické stanice (WS-5000, WS-2000, WS-2902C,...)",
  "addons.apiKey": "API klíč",
  "addons.applicationKey": "Aplikační klíč",
  "addons.connect": "Připojit",
  "addons.davisApiSecret": "Tajné API",
  "addons.davisApiV2Key": "Klíč API V2",
  "addons.davisDescription": "Davis meteorologické stanice (Vantage Vue, Vantage Pro2,...)",
  "addons.davisRetrieveApiKey": "Získejte své klíče API V2 z tohoto odkazu",
  "addons.disconnect": "Odpojit",
  "addons.ecowittCreateAndRetrieveKeys": "Vytvořte a načtěte klíč API a klíč aplikace z tohoto odkazu",
  "addons.ecowittDescription": "Ecowitt poskytuje profesionální meteostanice, bezdrátové vnitřní/venkovní teploměry, vysoce přesné srážkoměry, senzory kvality vzduchu a mnoho dalšího.",
  "addons.helpLink": "Jak připojit {provider}",
  "addons.myAcuriteAccountOnHold": "Váš účet byl pozastaven. Chcete-li znovu připojit svůj účet, zadejte své heslo",
  "addons.myAcuriteDescription": "AcuRite je značka meteostanic číslo 1 v Severní Americe. Jako lídr v technologii času, teploty a počasí vám AcuRite poskytuje podrobné informace o vašem vnitřním a venkovním prostředí, abyste si mohli s jistotou naplánovat svůj den.",
  "addons.myAcuriteEnterCredentials": "Zadejte své přihlašovací údaje My AcuRite, abyste mohli propojit svůj účet My AcuRite se SmartMixin",
  "addons.netatmoEnergy": "Netatmo Energy",
  "addons.netatmoEnergyDescription": "Pomocí termostatu Netatmo můžete měnit teplotu svého domova z postele nebo z druhé strany světa.",
  "addons.netatmoThermostat": "Netatmo termostat",
  "addons.netatmoWeather": "Počasí Netatmo",
  "addons.netatmoWeatherDescription": "Sledujte vaše klimatická měření na smartphonu.",
  "addons.or": "nebo",
  "addons.providerAccountDisconnected": "Připojení k vaší meteorologické službě vypršelo. Pro obnovení aktualizací dat se prosím znovu připojte.",
  "addons.reconnect": "Znovu připojit",
  "addons.weatherflowCreateToken": "Vytvořte a získejte svůj token z tohoto odkazu",
  "addons.weatherflowTempestDescription": "Meteorologická stanice Tempest vyvinutá společností Weatherflow",
  "addons.wundergroundApiKey": "API klíč",
  "addons.wundergroundDescription": "Weather Underground je globální komunita lidí, kteří propojují data z environmentálních senzorů, jako jsou meteorologické stanice a monitory kvality ovzduší, abychom vám mohli dodat bohatá, hyperlokální data, která potřebujete k podpoře vašich vášní.",
  "addons.wundergroundRetrieveApiKey": "Získejte svůj API klíč z tohoto odkazu",
  "addons.wundergroundStationId": "ID stanice",
  "airQuality.adviceActivityGood": "Ideální den na pohyb venku",
  "airQuality.adviceActivityHazardous": "Vyhněte se veškeré fyzické aktivitě venku",
  "airQuality.adviceActivityLabel": "Fyzická aktivita",
  "airQuality.adviceActivityModerate": "Dobrý den na pohyb venku",
  "airQuality.adviceActivitySensitive": "Zvažte kratší a méně náročné aktivity venku",
  "airQuality.adviceActivityUnhealthy": "Omezte dlouhé nebo náročné aktivity a dělejte více přestávek",
  "airQuality.adviceActivityVeryUnhealthy": "Vyhněte se dlouhým nebo náročným aktivitám; zvažte přesun dovnitř",
  "airQuality.adviceGroupsGood": "Nejsou nutná žádná zvláštní opatření",
  "airQuality.adviceGroupsHazardous": "Zůstaňte uvnitř a omezte aktivitu",
  "airQuality.adviceGroupsLabel": "Citlivé skupiny",
  "airQuality.adviceGroupsModerate": "Neobvykle citliví lidé: kratší a méně náročné aktivity",
  "airQuality.adviceGroupsSensitive": "Kratší a méně náročné aktivity venku a více přestávek",
  "airQuality.adviceGroupsUnhealthy": "Vyhněte se dlouhým nebo náročným aktivitám venku; zvažte přesun dovnitř",
  "airQuality.adviceGroupsVeryUnhealthy": "Vyhněte se veškeré fyzické aktivitě venku; odložte ji nebo přesuňte dovnitř",
  "airQuality.adviceTimingLabel": "Kdy jít ven",
  "airQuality.adviceTimingMorning": "Nejlépe dopoledne — ozón je tehdy nižší",
  "airQuality.airQuality": "Kvalita ovzduší",
  "airQuality.airQualityIndex": "Index kvality ovzduší",
  "airQuality.aqiForecast": "Předpověď kvality ovzduší",
  "airQuality.co": "Kysličník uhelnatý",
  "airQuality.dailyForecast": "Denní předpověď",
  "airQuality.details": "Detaily",
  "airQuality.dominantPollutant": "Převažující znečišťující látka",
  "airQuality.expectedPeak": "Očekávaný vrchol",
  "airQuality.good": "Dobrá",
  "airQuality.goodDescription": "Kvalita ovzduší je považována za uspokojivou a znečištění ovzduší představuje malé nebo žádné riziko.",
  "airQuality.hazardous": "Nebezpečná",
  "airQuality.hazardousDescription": "Zdravotní upozornění: Kdokoli může zaznamenat závažnější zdravotní účinky.",
  "airQuality.indoorAirQuality": "Kvalita vnitřního vzduchu",
  "airQuality.mgm3": "mg/m³",
  "airQuality.moderate": "Průměrná",
  "airQuality.moderateDescription": "Kvalita vzduchu je přijatelná. U některých znečišťujících látek však může existovat zdravotní riziko pro velmi malý počet lidí neobvykle citlivých na znečištění ovzduší.",
  "airQuality.no2": "Oxid dusičitý",
  "airQuality.noForecastForLocation": "Pro toto místo není k dispozici předpověď kvality ovzduší.",
  "airQuality.now": "Nyní",
  "airQuality.o3": "Ozón",
  "airQuality.pm10": "Částice menší než 10μm",
  "airQuality.pm25": "Částice menší než 2,5μm",
  "airQuality.pollutants": "Znečišťující látky",
  "airQuality.ppb": "ppb",
  "airQuality.recommendations": "Doporučení",
  "airQuality.sensitiveUnhealthy": "Špatné pro citlivé skupiny",
  "airQuality.sensitiveUnhealthyDescription": "Kvalita vzduchu je přijatelná; U některých znečišťujících látek však může existovat mírný zdravotní problém u velmi malého počtu lidí, kteří jsou zvláště citliví na znečištění ovzduší.",
  "airQuality.so2": "Kysličník siřičitý",
  "airQuality.subIndex": "Dílčí index AQI",
  "airQuality.ugm3": "µg/m³",
  "airQuality.understandIndex": "Porozumět indexu",
  "airQuality.unhealthy": "Nezdravá",
  "airQuality.unhealthyDescription": "Každý může začít pociťovat účinky na zdraví; členové vnímavých skupin mohou pociťovat závažnější zdravotní účinky.",
  "airQuality.veryUnhealthy": "Velmi nezdravá",
  "airQuality.veryUnhealthyDezscription": "Zdravotní varování před nouzovými podmínkami. Je pravděpodobnější, že bude postižena celá populace.",
  "alerts.addAlert": "Přidat upozornění",
  "alerts.addCondition": "Přidat podmínku",
  "alerts.alertAdded": "Upozornění bylo úspěšně přidáno",
  "alerts.alertAuthorizationNotice": "Upozornění mohou fungovat, pouze pokud povolíte SmartMixin zobrazovat upozornění",
  "alerts.alertDeleted": "Upozornění bylo úspěšně smazáno",
  "alerts.alertEdited": "Upozornění bylo úspěšně upraveno",
  "alerts.alertName": "Název upozornění",
  "alerts.alertWhen": "Chci být upozorněn",
  "alerts.aqiGreaterThan": "AQI větší než",
  "alerts.aqiGreaterThanThreshold": "AQI nad prahovou hodnotou {value}{unit}",
  "alerts.aqiLessThan": "AQI méně než",
  "alerts.aqiLessThanThreshold": "AQI pod prahovou hodnotou {value}{unit}",
  "alerts.atLeastOneCondition": "Musíte přidat alespoň jednu podmínku",
  "alerts.co2GreaterThan": "CO2 větší než",
  "alerts.co2GreaterThanThreshold": "CO2 nad prahovou hodnotou {value}{unit}",
  "alerts.co2LessThan": "CO2 méně než",
  "alerts.co2LessThanThreshold": "CO2 pod prahovou hodnotou {value}{unit}",
  "alerts.conditions": "Podmínky",
  "alerts.createAlert": "Vytvořit upozornění",
  "alerts.dailyPrecipitationGreaterThan": "Denní srážky větší než",
  "alerts.dailyPrecipitationGreaterThanThreshold": "Denní srážky nad prahem {value}{unit}",
  "alerts.deleteAlert": "Smazat upozornění",
  "alerts.editAlert": "Upravit upozornění",
  "alerts.editCondition": "Změnit podmínku",
  "alerts.gustSpeedGreaterThan": "Poryv větší než",
  "alerts.gustSpeedGreaterThanThreshold": "Poryv nad prahovou hodnotou {value}{unit}",
  "alerts.gustSpeedLessThan": "Poryv méně než",
  "alerts.gustSpeedLessThanThreshold": "Poryv pod prahovou hodnotou {value}{unit}",
  "alerts.heatIndexGreaterThan": "Tepelný index více než",
  "alerts.heatIndexGreaterThanThreshold": "Tepelný index nad prahovou hodnotou {value}{unit}",
  "alerts.heatIndexLessThan": "Tepelný index méně než",
  "alerts.heatIndexLessThanThreshold": "Tepelný index pod prahovou hodnotou {value}{unit}",
  "alerts.humidexGreaterThan": "Humidex více než",
  "alerts.humidexGreaterThanThreshold": "Humidex nad prahovou hodnotou {value}{unit}",
  "alerts.humidexLessThan": "Humidex méně než",
  "alerts.humidexLessThanThreshold": "Humidex pod prahovou hodnotou {value}{unit}",
  "alerts.humidityGreaterThan": "Vlhkost nahoře",
  "alerts.humidityGreaterThanThreshold": "Vlhkost nad prahovou hodnotou {value}{unit}",
  "alerts.humidityLessThan": "Vlhkost níže",
  "alerts.humidityLessThanThreshold": "Vlhkost pod prahovou hodnotou {value}{unit}",
  "alerts.inProgress": "Probíhá",
  "alerts.myAlerts": "Moje upozornění",
  "alerts.noConfiguredAlert": "Ještě nemáte upozornění, přidejte ho",
  "alerts.noiseGreaterThan": "Hluk větší než",
  "alerts.noiseGreaterThanThreshold": "Hluk nad prahovou hodnotou {value}{unit}",
  "alerts.noiseLessThan": "Hluk menší než",
  "alerts.noiseLessThanThreshold": "Hluk pod prahovou hodnotou {value}{unit}",
  "alerts.noteOnConditions": "Upozornění se spustí, když jsou ověřeny všechny níže uvedené podmínky",
  "alerts.noTriggerHistory": "Toto upozornění zatím nebylo spuštěno.",
  "alerts.pm10GreaterThan": "PM 10 větší než",
  "alerts.pm10GreaterThanThreshold": "PM 10 nad prahovou hodnotou {value}{unit}",
  "alerts.pm10LessThan": "PM 10 méně než",
  "alerts.pm10LessThanThreshold": "PM 10 pod prahovou hodnotou {value}{unit}",
  "alerts.pm1GreaterThan": "PM 1 větší než",
  "alerts.pm1GreaterThanThreshold": "PM 1 nad prahovou hodnotou {value}{unit}",
  "alerts.pm1LessThan": "PM 1 méně než",
  "alerts.pm1LessThanThreshold": "PM 1 pod prahovou hodnotou {value}{unit}",
  "alerts.pm2p5GreaterThan": "PM 2,5 větší než",
  "alerts.pm2p5GreaterThanThreshold": "PM 2,5 nad prahovou hodnotou {value}{unit}",
  "alerts.pm2p5LessThan": "PM 2,5 méně než",
  "alerts.pm2p5LessThanThreshold": "PM 2,5 pod prahovou hodnotou {value}{unit}",
  "alerts.postStormSummary": "Souhrn po dešti",
  "alerts.postStormSynopsisHelper": "Po skončení každého deště obdržíte souhrnné oznámení.",
  "alerts.postStormSynopsisSoleCondition": "Souhrn po bouři nelze kombinovat s jinými podmínkami.",
  "alerts.precipitationGreaterThan": "Hodinové srážky větší než",
  "alerts.precipitationGreaterThanThreshold": "Hodinové srážky nad prahem {value}{unit}",
  "alerts.pressureGreaterThan": "Tlak větší než",
  "alerts.pressureGreaterThanThreshold": "Tlak nad prahovou hodnotou {value}{unit}",
  "alerts.pressureLessThan": "Tlak menší než",
  "alerts.pressureLessThanThreshold": "Tlak pod prahovou hodnotou {value}{unit}",
  "alerts.rainRateGreaterThan": "Intenzita deště větší než",
  "alerts.rainRateGreaterThanThreshold": "Intenzita deště nad prahem {value}{unit}",
  "alerts.solarRadiationGreaterThan": "Sluneční záření větší než",
  "alerts.solarRadiationGreaterThanThreshold": "Sluneční záření nad prahovou hodnotou {value}{unit}",
  "alerts.solarRadiationLessThan": "Sluneční záření méně než",
  "alerts.solarRadiationLessThanThreshold": "Sluneční záření pod prahovou hodnotou {value}{unit}",
  "alerts.stormChartUnavailable": "Historie srážek pro tento déšť není k dispozici.",
  "alerts.stormDetail": "Souhrn deště",
  "alerts.stormDuration": "Doba trvání",
  "alerts.stormEnd": "Konec",
  "alerts.stormPeakRate": "Maximální intenzita deště",
  "alerts.stormStart": "Začátek",
  "alerts.stormTotal": "Celkové srážky",
  "alerts.temperatureGreaterThan": "Teplota nad",
  "alerts.temperatureGreaterThanThreshold": "Teplota nad prahovou hodnotou {value}{unit}",
  "alerts.temperatureLessThan": "Teplota níže",
  "alerts.temperatureLessThanThreshold": "Teplota pod prahovou hodnotou {value}{unit}",
  "alerts.thswGreaterThan": "THSW více než",
  "alerts.thswGreaterThanThreshold": "THSW nad prahovou hodnotou {value}{unit}",
  "alerts.thswLessThan": "THSW méně než",
  "alerts.thswLessThanThreshold": "THSW pod prahovou hodnotou {value}{unit}",
  "alerts.thwGreaterThan": "THW více než",
  "alerts.thwGreaterThanThreshold": "THW nad prahovou hodnotou {value}{unit}",
  "alerts.thwLessThan": "THW méně než",
  "alerts.thwLessThanThreshold": "THW pod prahovou hodnotou {value}{unit}",
  "alerts.triggerHistory": "Historie upozornění",
  "alerts.uvGreaterThan": "UV větší než",
  "alerts.uvGreaterThanThreshold": "UV nad prahovou hodnotou {value}{unit}",
  "alerts.uvLessThan": "UV nižší než",
  "alerts.uvLessThanThreshold": "UV pod prahovou hodnotou {value}{unit}",
  "alerts.visibilityGreaterThanThreshold": "Viditelnost nad prahovou hodnotou {value}{unit}",
  "alerts.visibilityLessThanThreshold": "Viditelnost pod prahovou hodnotou {value}{unit}",
  "alerts.visiblityGreaterThan": "Viditelnost menší než",
  "alerts.visiblityLessThan": "Viditelnost menší než",
  "alerts.whichMeasure": "Na jaké opatření chcete být upozorněni?",
  "alerts.whichModule": "Na který modul byste chtěli být upozorněni?",
  "alerts.windChillGreaterThan": "Wind Chill více než",
  "alerts.windChillGreaterThanThreshold": "Wind Chill nad prahovou hodnotou {value}{unit}",
  "alerts.windChillLessThan": "Wind Chill méně než",
  "alerts.windChillLessThanThreshold": "Wind Chill pod prahovou hodnotou {value}{unit}",
  "alerts.windSpeedGreaterThan": "Vítr větší než",
  "alerts.windSpeedGreaterThanThreshold": "Vítr nad prahovou hodnotou {value}{unit}",
  "alerts.windSpeedLessThan": "Vítr méně než",
  "alerts.windSpeedLessThanThreshold": "Vítr pod prahovou hodnotou {value}{unit}",
  "astral.aboveHorizonAllDay": "Celý den nad obzorem",
  "astral.aboveTheHorizon": "nad obzorem",
  "astral.apparentSize": "Úhlová velikost",
  "astral.apparentSizeAcross": "o průměru {size}",
  "astral.astronomicalDawn": "Astronomický úsvit",
  "astral.astronomicalDusk": "Astronomický soumrak",
  "astral.astronomicalSunPhase": "{sunPhase} astronomická",
  "astral.belowHorizonAllDay": "Celý den pod obzorem",
  "astral.belowHorizonSince": "Pod obzorem od {time}",
  "astral.belowHorizonSinceOn": "Pod obzorem od {day} {time}",
  "astral.brightAllNight": "Světlá obloha celou noc — nikdy úplná tma",
  "astral.brightestMoment": "Nejsvětlejší okamžik",
  "astral.civilDawn": "Občanský úsvit",
  "astral.civilDusk": "Občanský soumrak",
  "astral.civilSunPhase": "{sunPhase} civilní",
  "astral.darkSkyBetween": "Tmavá obloha {from} → {to}",
  "astral.darkSkyWindow": "Tmavá obloha {from} → {to} · {duration} bez Měsíce",
  "astral.dawn": "Svítání",
  "astral.dayLength": "Délka dne",
  "astral.daylightThroughTheYear": "Délka dne v průběhu roku",
  "astral.dayOfCycle": "den {day} z {total}",
  "astral.doesNotOccurToday": "Dnes nenastává",
  "astral.domeHint": "Tažením projděte nocí",
  "astral.domeReadout": "{time} · {altitude} · {direction}",
  "astral.dusk": "Soumrak",
  "astral.earliestSunrise": "Nejdřívější východ slunce",
  "astral.earliestSunset": "Nejdřívější západ slunce",
  "astral.equinox": "Rovnodennost",
  "astral.equinoxIn": "Rovnodennost za {days, plural, one {# den} few {# dny} many {# dne} other {# dní}}",
  "astral.evening": "Večer",
  "astral.exactPhaseAt": "Přesně v {time}",
  "astral.firstQuarter": "První čtvrť",
  "astral.firstSunriseIn": "První východ slunce za {days, plural, one {# den} few {# dny} many {# dne} other {# dní}}",
  "astral.firstSunsetIn": "První západ slunce za {days, plural, one {# den} few {# dny} many {# dne} other {# dní}}",
  "astral.fullMoon": "Úplněk",
  "astral.goldenHourBegins": "Začátek zlaté hodiny",
  "astral.goldenHourEnds": "Konec zlaté hodiny",
  "astral.highestPoint": "Nejvyšší bod",
  "astral.inDays": "za {days, plural, one {# den} few {# dny} many {# dne} other {# dní}}",
  "astral.lastQuarter": "Poslední čtvrť",
  "astral.latestSunrise": "Nejpozdější východ slunce",
  "astral.latestSunset": "Nejpozdější západ slunce",
  "astral.litShort": "Osvětl.",
  "astral.longestDay": "Nejdelší den",
  "astral.lowestPoint": "Nejnižší bod",
  "astral.maxAltitudeShort": "Max",
  "astral.midday": "Poledne",
  "astral.midnightSun": "Půlnoční slunce",
  "astral.midnightSunPeriod": "Půlnoční slunce",
  "astral.milestoneFootnotePolar": "Slunce zde {days, plural, one {# den} few {# dny} other {# dní}} v roce nevychází ani nezapadá, a tak seznam místo obvyklých extrémů východu a západu ukazuje, kdy k tomu dochází.",
  "astral.milestoneFootnoteTemperate": "Nejčasnější západ a nejpozdější východ nepřipadají na nejkratší den — tato dvě data určuje časová rovnice, nikoli slunovrat.",
  "astral.moon": "Měsíc",
  "astral.moonAltitude": "Výška",
  "astral.moonDirection": "Azimut",
  "astral.moonDistance": "Vzdálenost",
  "astral.moonlessFor": "{duration} bez Měsíce",
  "astral.moonPhases": "Fáze Měsíce",
  "astral.moonrise": "Východ Měsíce",
  "astral.moonset": "Západ Měsíce",
  "astral.moonUpAllNight": "Měsíc je nad obzorem celou noc",
  "astral.moonWashesOutNight": "Měsíc je nad obzorem od {rise} do {set} a prosvětluje celou noc",
  "astral.morning": "Ráno",
  "astral.nauticalDawn": "Nautický úsvit",
  "astral.nauticalDusk": "Nautický soumrak",
  "astral.nauticalSunPhase": "{sunPhase} námořní",
  "astral.newMoon": "Nov",
  "astral.nextDay": "+1 den",
  "astral.nextProperlyDarkNight": "Příští opravdu tmavá noc",
  "astral.nextRise": "příští východ v {time}",
  "astral.nextRiseOn": "příští východ {day} v {time}",
  "astral.nextSevenNights": "Příštích sedm nocí",
  "astral.noAstronomicalDarknessTonight": "Dnes v noci žádná astronomická tma",
  "astral.noDarkNightAhead": "Žádná v příštích dvou týdnech",
  "astral.noon": "Poledne",
  "astral.noSunriseToday": "Dnes slunce nevychází",
  "astral.nowAtBearing": "nyní {altitude} · azimut {direction}",
  "astral.observing": "Pozorování",
  "astral.ofDaylightLeft": "denního světla zbývá",
  "astral.overTheNextThreeWeeks": "během příštích 3 týdnů",
  "astral.percentLit": "osvětlení {percent}",
  "astral.polarNight": "Polární noc",
  "astral.polarNightPeriod": "Polární noc",
  "astral.remainingDaylight": "Zbývající denní světlo",
  "astral.rightNow": "Právě teď",
  "astral.riseShort": "Východ",
  "astral.setShort": "Západ",
  "astral.shortestDay": "Nejkratší den",
  "astral.solarNoon": "Pravé poledne",
  "astral.solstice": "Slunovrat",
  "astral.sunBelowHorizon": "Slunce {degrees}° pod obzorem",
  "astral.sunEvents": "Sluneční události",
  "astral.sunNeverDarkEnough": "Slunce nikdy neklesne 18° pod obzor",
  "astral.sunNeverSets": "Slunce nezapadá",
  "astral.sunrise": "Východ slunce",
  "astral.sunriseAndSunset": "Východ a západ slunce",
  "astral.sunriseAt": "Východ slunce v {time}",
  "astral.sunset": "Západ slunce",
  "astral.sunsetAt": "Západ slunce v {time}",
  "astral.thisYearAtNorth": "Letos na {degrees}° s. š.",
  "astral.thisYearAtSouth": "Letos na {degrees}° j. š.",
  "astral.tonight": "Dnes v noci",
  "astral.totalDaylight": "Celkové denní světlo",
  "astral.twilightAllNight": "Soumrak celou noc — nikdy úplná tma",
  "astral.upFor": "{duration} nad obzorem",
  "astral.usableLight": "Využitelné světlo",
  "astral.vsAverage": "{percent} oproti průměru",
  "astral.vsYesterday": "oproti včerejšku",
  "astral.waningCrescent": "Ubývající srpek",
  "astral.waningGibbous": "Ubývající vypouklý měsíc",
  "astral.waxingCrescent": "Dorůstající srpek",
  "astral.waxingGibbous": "Dorůstající vypouklý měsíc",
  "astral.whereToLook": "Kam se dívat",
  "astral.withoutTheMoon": "{duration} bez Měsíce",
  "auth.alreadyHaveAccount": "Už máte účet?",
  "auth.authContainerTagline": "Váš osobní panel počasí. Připojte své stanice a získejte data v reálném čase na dosah ruky.",
  "auth.backToLogin": "Zpět na přihlášení",
  "auth.catchPhrase": "Platforma meteorologické inteligence",
  "auth.checkYourEmail": "Zkontrolujte svůj e-mail",
  "auth.continueWithApple": "Pokračovat přes Apple",
  "auth.continueWithFacebook": "Pokračovat přes Facebook",
  "auth.continueWithGoogle": "Pokračovat přes Google",
  "auth.email": "E-mailová adresa",
  "auth.emailRequiredLoginFacebook": "Emailová adresa je vyžadována při přihlášení pomocí Facebooku",
  "auth.emailVerification": "Potvrzení e-mailu",
  "auth.emailVerificationFailure": "Při ověřování vašeho e-mailu došlo k problému.",
  "auth.emailVerificationSuccess": "Váš email byl úspěšně ověřen.",
  "auth.firstName": "Jméno",
  "auth.forgotPassword": "Zapomenuté heslo",
  "auth.forgotPasswordSubtitle": "Zadejte svůj e-mail a my vám zašleme odkaz pro resetování hesla.",
  "auth.lastName": "Příjmení",
  "auth.login": "Uživatelské jméno",
  "auth.loginSubtitle": "Vítejte zpět! Zadejte prosím své údaje.",
  "auth.loginToSmartMixinDescription": "Zadejte své přihlašovací údaje SmartMixin pro přístup ke svému účtu.",
  "auth.logout": "Odhlásit",
  "auth.logoutConfirmation": "Opravdu se chcete odpojit?",
  "auth.noAccountYet": "Ještě nemáte účet?",
  "auth.or": "nebo",
  "auth.password": "Heslo",
  "auth.passwordAgain": "Znovu heslo",
  "auth.passwordReset": "Resetovat heslo",
  "auth.passwordResetSuccess": "Vaše heslo bylo úspěšně změněno.",
  "auth.register": "Registrovat",
  "auth.registerDescription": "Vytvořte si bezplatný účet SmartMixin pro připojení vašich meteorologických stanic, sledování dat o počasí a přístup k výkonným analytickým nástrojům.",
  "auth.registerSubtitle": "Vytvořte si účet a začněte.",
  "auth.registerSuccess": "Úspěšně jste se zaregistrovali! Právě jsme vám zaslali ověřovací odkaz na adresu {emailAddress} s dalšími pokyny.",
  "auth.restorePassword": "Obnovit heslo",
  "auth.restorePasswordSuccess": "Právě jsme vám zaslali odkaz pro resetování hesla na {emailAddress} s dalšími pokyny.",
  "auth.sendReset": "Odeslat pokyny k resetování",
  "auth.signInWithApple": "",
  "auth.socialAccount": "nebo použijte svůj účet",
  "auth.staffVerificationCode": "Ověřovací kód",
  "auth.staffVerificationExpiresIn": "Ověřeno. Platnost vyprší za {duration}.",
  "auth.staffVerificationInvalidCode": "Nesprávný kód. Zkuste to znovu.",
  "auth.staffVerificationLoginAsStopped": "Login As byl ukončen: pro pokračování zadejte ověřovací kód na obrazovce Debug.",
  "auth.staffVerificationNotEnrolled": "Pro váš účet není nastavena žádná ověřovací aplikace. Přidejte ji v nastavení zabezpečení v administraci.",
  "auth.staffVerificationPrompt": "Zadejte 6místný kód z ověřovací aplikace nebo kód pro obnovení, abyste mohli používat Login As a vyhledávání uživatelů.",
  "auth.staffVerificationSetupLink": "Přidat ověřovací aplikaci",
  "auth.staffVerificationSubmit": "Ověřit",
  "auth.staffVerificationTitle": "Ověření personálu",
  "auth.welcome": "Vítejte v SmartMixin",
  "auth.welcomeBack": "Vítejte zpět!",
  "calendar.april": "Duben",
  "calendar.august": "Srpen",
  "calendar.dateFormat": "datový formát",
  "calendar.day": "Den",
  "calendar.december": "Prosinec",
  "calendar.end": "Konec",
  "calendar.february": "Únor",
  "calendar.hours": "hodiny",
  "calendar.hoursShort": "h",
  "calendar.january": "Leden",
  "calendar.july": "Červenec",
  "calendar.june": "Červen",
  "calendar.last24Hours": "posledních 24 hodin",
  "calendar.last30Days": "posledních 30 dní",
  "calendar.last7Days": "posledních 7 dní",
  "calendar.march": "Březen",
  "calendar.max": "Max",
  "calendar.may": "Květen",
  "calendar.month": "Měsíc",
  "calendar.months": "měsíce",
  "calendar.november": "Listopad",
  "calendar.october": "Říjen",
  "calendar.oneDay": "1 den",
  "calendar.oneHour": "1 hodina",
  "calendar.oneMonth": "1 měsíc",
  "calendar.oneWeek": "1 týden",
  "calendar.previous24Hours": "Předchozích 24 hodin",
  "calendar.previous30Days": "Předchozích 30 dní",
  "calendar.previous7Days": "Předchozích 7 dní",
  "calendar.previousDay": "Předchozím dnem",
  "calendar.previousMonth": "Předchozím měsícem",
  "calendar.previousWeek": "Předchozím týdnem",
  "calendar.previousYear": "Předchozím rokem",
  "calendar.sameDayLastYear": "Stejným dnem minulý rok",
  "calendar.sameMonthLastYear": "Stejným měsícem minulý rok",
  "calendar.selectADate": "Vyberte datum",
  "calendar.selectAggregation": "Vyberte zobrazenou hodnotu",
  "calendar.selectAMonth": "Vyberte měsíc",
  "calendar.selectAYear": "Vyberte rok",
  "calendar.selectGranularity": "Vyberte podrobnost",
  "calendar.selectTimescale": "Vyberte časové měřítko",
  "calendar.september": "Září",
  "calendar.sixHours": "6 hodin",
  "calendar.start": "Začátek",
  "calendar.thirtyMinutes": "30 min",
  "calendar.threeHours": "3 hodiny",
  "calendar.use24HourFormat": "Použijte 24hodinový formát",
  "calendar.week": "Týden",
  "calendar.year": "Rok",
  "calendar.yesterday": "Včera",
  "common.accountDeleted": "Váš účet byl úspěšně smazán.",
  "common.accountOnHold": "Připojení vašeho účtu vypršelo. Pro obnovení aktualizací dat se prosím znovu připojte.",
  "common.add": "Přidat",
  "common.addAStation": "Přidat stanici",
  "common.addToFavorites": "Přidat do oblíbených",
  "common.addYourOwnStation": "Přidejte svou stanici",
  "common.afternoon": "Odpoledne",
  "common.alreadyPremium": "Již máte prémiový účet!",
  "common.alsoAvailableOn": "K dispozici také na:",
  "common.altitude": "Nadmořská výška",
  "common.analysis": "Analýza",
  "common.aroundMe": "Kolem mě",
  "common.articleCount": "{count, plural, one {# článek} few {# články} many {# článků} other {# článků}}",
  "common.articleNotFound": "Článek nenalezen",
  "common.articleNotFoundDescription": "Článek, který hledáte, neexistuje.",
  "common.average": "Průměr",
  "common.averageOverThePeriod": "Průměr za období",
  "common.away": "Pryč",
  "common.back": "Zpět",
  "common.backToHelpCenter": "Zpět do centra nápovědy",
  "common.backToHome": "Zpět na Hlavní Stránku",
  "common.bad": "Špatný",
  "common.batteryLevel": "Stav baterie",
  "common.bestValue": "Nejlepší Hodnota",
  "common.billingDetailsAndroid": "U bezplatné zkušební nabídky vám nebudou účtovány poplatky, pokud zrušíte 24 hodin před vypršením úvodního období zdarma. Po skončení zkušební verze můžete předplatné SmartMixin kdykoli zrušit prostřednictvím nastavení účtu Google Play nebo bude automaticky obnoveno. To musí být provedeno 24 hodin před koncem období předplatného, aby vám nebyl účtován další poplatek zobrazený na tlačítku výše. Platby za předplatné budou účtovány na váš účet Google Play při potvrzení nákupu a při zahájení každého obnovovací termín.",
  "common.billingDetailsIos": "U bezplatné zkušební nabídky vám nebudou účtovány poplatky, pokud zrušíte 24 hodin před vypršením úvodního období zdarma. Po skončení zkušební verze můžete předplatné SmartMixin kdykoli zrušit prostřednictvím nastavení účtu App Store nebo bude automaticky obnoveno. To musí být provedeno 24 hodin před koncem období předplatného, aby vám nebyl účtován další poplatek zobrazený na tlačítku výše. Platby za předplatné budou účtovány na váš účet App Store při potvrzení nákupu a při zahájení každého obnovovací termín.",
  "common.boilerOn": "Ohřev zapnutý",
  "common.browseByCategory": "Procházet podle kategorie",
  "common.calendarView": "Zobrazení kalendáře",
  "common.cancel": "Zrušit",
  "common.cannotBeEmpty": "Toto pole nemůže být prázdné.",
  "common.cardDetails": "Podrobnosti o kartě",
  "common.categoryNotFound": "Kategorie nenalezena",
  "common.categoryNotFoundDescription": "Tato kategorie neexistuje nebo neobsahuje žádné články.",
  "common.charts": "Grafy",
  "common.chartView": "Zobrazení grafu",
  "common.clearRecentLocations": "Vyčistit vše",
  "common.close": "Zavřít",
  "common.co2Fresh": "Čerstvý",
  "common.co2GettingStale": "Zhoršuje se",
  "common.co2Stale": "Vydýchaný",
  "common.comparison": "Srovnání",
  "common.contactMe": "Kontaktujte mě",
  "common.currentDay": "Dnes",
  "common.currentLocation": "Aktuální umístění",
  "common.currentObservations": "Aktuální pozorování",
  "common.currentRainEvent": "Aktuální déšť",
  "common.currentRate": "Intenzita deště",
  "common.currentWeatherConditions": "Aktuální podmínky",
  "common.customizeComparisonMetrics": "Přizpůsobit metriky srovnání",
  "common.customizeComparisonMetricsDescription": "Přetáhněte položky pro změnu pořadí metrik srovnání. Klepněte na ikonu oka pro zobrazení nebo skrytí metrik.",
  "common.customizeDashboard": "Přizpůsobit",
  "common.customizeDashboardDescription": "Přetáhněte položky pro změnu pořadí na nástěnce. Klepněte na ikonu oka pro zobrazení nebo skrytí sekcí.",
  "common.customizedStationName": "Vlastní název stanice",
  "common.dailyForecast": "Denní předpověď",
  "common.dashboard": "Panel",
  "common.dayRangeExpected": "{value} očekáváno v {time}",
  "common.dayRangeReached": "{value} v {time}",
  "common.dayRangeSteady": "Stabilně {value} celý den",
  "common.default": "Výchozí",
  "common.defaultForecastModelChip": "Výchozí · {name}",
  "common.delete": "Vymazat",
  "common.deleteAccount": "smazat účet",
  "common.deleteAccountConfirmation": "Opravdu chcete smazat svůj účet? Tato akce je nevratná.",
  "common.deleteAccountDescription": "Tato akce smaže váš účet a všechny vaše informace. Není cesty zpět.",
  "common.details": "Detaily",
  "common.durationHours": "{hours} h",
  "common.durationHoursMinutes": "{hours} h {minutes} min",
  "common.durationMinutes": "{minutes} min",
  "common.durationMinutesSeconds": "{minutes} min {seconds} s",
  "common.durationSeconds": "{seconds} s",
  "common.edit": "Upravit",
  "common.editor": "Editor",
  "common.endTime": "Konec",
  "common.evening": "Večer",
  "common.exitFullscreen": "Ukončit celou obrazovku",
  "common.exploreWeatherMap": "Prozkoumat Mapu Počasí",
  "common.favoriteLocations": "Oblíbené",
  "common.favoriteLocationsEmpty": "Můžete přidat až 5 oblíbených míst.",
  "common.favoriteStations": "Oblíbená stanice",
  "common.feedbackHelpsImprove": "Vaše připomínky nám pomáhají zlepšovat naše články nápovědy.",
  "common.feedbackReasonNotAnswer": "Neodpovídá na mou otázku",
  "common.feedbackReasonOutdated": "Informace jsou zastaralé",
  "common.feedbackReasonUnclear": "Pokyny jsou nejasné",
  "common.feedbackWhatWentWrong": "V čem byl problém?",
  "common.filterStationDescription": "Nezobrazujte stanice s nespolehlivými opatřeními",
  "common.filterStations": "Filtrační stanice",
  "common.filterStationSourceDescription": "Vyberte poskytovatele stanic, které chcete zobrazit na mapě",
  "common.findStationsNearYou": "Najít stanice ve vašem okolí",
  "common.firmwareVersion": "Verze firmwaru",
  "common.forecast": "Předpověď",
  "common.forecastAllModels": "Všechny modely ({count})",
  "common.forecastComparisonDescription": "Snadno porovnávejte data z různých dostupných modelů počasí",
  "common.forecastFollowingPreferences": "Podle vašich předvoleb",
  "common.forecastModelComparison": "Porovnání modelů počasí",
  "common.forecastModelCoverage": "Pokrytí",
  "common.forecastModelDescription": "Popis",
  "common.forecastModelDescription_AROME": "Vysokorozlišovací model Météo France umožňující řešení konvekce nad západní Evropou s rozlišením 1,3 km. Nejlepší ve své třídě pro krátkodobé předpovědi ve Francii; aktualizován každé tři hodiny.",
  "common.forecastModelDescription_ARPEGE_EU": "Evropský nest modelu ARPEGE Météo France s rozlišením 10 km. Střednědobé předpovědi nad Evropou, aktualizované čtyřikrát denně.",
  "common.forecastModelDescription_ARPEGE_GLOBAL": "Globální numerický model počasí Météo France s rozlišením 25 km, běžící asi 4 dny. Aktualizován čtyřikrát denně.",
  "common.forecastModelDescription_DMI_DINI": "HARMONIE DINI od DMI: konvekci umožňující model nad severozápadní Evropou — Dánsko, Benelux, Irsko, Spojené království a Skandinávie — s rozlišením 2 km běžící až 60 hodin, aktualizován osmkrát denně. Obsahuje upravená otevřená data DMI (CC BY 4.0).",
  "common.forecastModelDescription_EC_GDPS": "Globální deterministický predikční systém Environment Canada: celosvětový střednědobý model s rozlišením 15 km běžící až 10 dní, aktualizován dvakrát denně.",
  "common.forecastModelDescription_EC_HRDPS": "Vysoce rozlišený deterministický predikční systém Environment Canada: konvekci umožňující model nad Kanadou a severními Spojenými státy s rozlišením 2,5 km běžící až 48 hodin, aktualizován čtyřikrát denně.",
  "common.forecastModelDescription_EC_RDPS": "Regionální deterministický predikční systém Environment Canada: střednědobý model nad Severní Amerikou s rozlišením 10 km, aktualizován čtyřikrát denně.",
  "common.forecastModelDescription_ECMWF_HRES": "Vlajkový model s vysokým rozlišením (IFS) Evropského centra pro střednědobé předpovědi počasí, všeobecně považovaný za nejlepší globální předpovědní systém na světě. Pokrývá celou planetu v rozlišení 25 km až na 15 dní, aktualizován čtyřikrát denně. Obsahuje upravená otevřená data ECMWF (CC BY 4.0).",
  "common.forecastModelDescription_GFS": "Vlajkový střednědobý globální model NOAA. Pokrývá celou planetu s rozlišením 25 km až do 16 dní, aktualizován čtyřikrát denně.",
  "common.forecastModelDescription_HRRR_CONUS": "Vysoce rozlišená rychlá aktualizace NOAA: model umožňující řešení konvekce nad kontinentálními Spojenými státy s rozlišením 3 km, aktualizovaný každou hodinu. Nejvhodnější pro velmi krátkodobé předpovědi bouřek a silných meteorologických jevů.",
  "common.forecastModelDescription_ICON": "Globální model ICON od DWD s rozlišením 13 km pokrývající celou planetu až na 7,5 dne, aktualizovaný čtyřikrát denně. Datenbasis: Deutscher Wetterdienst.",
  "common.forecastModelDescription_ICON_2I": "ICON-2I od ItaliaMeteo, provozovaný společně s ARPAE: konvekci umožňující model nad Itálií s rozlišením 2,2 km běžící až 72 hodin, aktualizován dvakrát denně. Obsahuje otevřená data ItaliaMeteo (CC BY 4.0).",
  "common.forecastModelDescription_ICON_CH1": "Kontrolní běh ICON-CH1-EPS od MeteoSwiss: konvekci umožňující model nad Alpami s rozlišením 1 km běžící až 33 hodin, aktualizován každé tři hodiny.",
  "common.forecastModelDescription_ICON_CH2": "Kontrolní běh ICON-CH2-EPS od MeteoSwiss: konvekci umožňující model nad Alpami — Švýcarsko a okolní alpský region — s rozlišením 2,1 km běžící až 120 hodin, aktualizován čtyřikrát denně.",
  "common.forecastModelDescription_ICON_DE": "Vysokorozlišovací model DWD umožňující řešení konvekce nad Německem a sousedními zeměmi s rozlišením 2,2 km. Krátkodobé předpovědi aktualizované dvakrát denně. Datenbasis: Deutscher Wetterdienst.",
  "common.forecastModelDescription_ICON_EU": "Evropský nest modelu ICON DWD s rozlišením 7 km pokrývající Evropu a severní Atlantik. Střednědobé předpovědi aktualizované čtyřikrát denně. Datenbasis: Deutscher Wetterdienst.",
  "common.forecastModelDescription_MET_NORWAY": "Otevřená služba předpovědi počasí Norského meteorologického ústavu, která kombinuje severské modely s vysokým rozlišením s daty ECMWF a poskytuje celosvětové předpovědi až 10 dní dopředu.",
  "common.forecastModelDescription_MF_AROME_ANTILLES": "Nest AROME nad francouzskými Antilami (Guadeloupe, Martinik) s rozlišením 2,5 km. Krátkodobé předpovědi aktualizované čtyřikrát denně.",
  "common.forecastModelDescription_MF_AROME_GUYANE": "Nest AROME nad Francouzskou Guyanou s rozlišením 2,5 km. Krátkodobé předpovědi aktualizované čtyřikrát denně.",
  "common.forecastModelDescription_MF_AROME_NOUVELLE_CALEDONIE": "Nest AROME nad Novou Kaledonií s rozlišením 2,5 km. Krátkodobé předpovědi aktualizované čtyřikrát denně.",
  "common.forecastModelDescription_MF_AROME_POLYNESIE": "Nest AROME nad Francouzskou Polynésií s rozlišením 2,5 km. Krátkodobé předpovědi aktualizované čtyřikrát denně.",
  "common.forecastModelDescription_MF_AROME_REUNION_MAYOTTE": "Nest AROME nad Réunionem a Mayotte s rozlišením 2,5 km. Krátkodobé předpovědi aktualizované čtyřikrát denně.",
  "common.forecastModelDescription_RRFS_CONUS": "Systém Rapid Refresh Forecast od NOAA nad kontinentálními USA s rozlišením 3 km. Hodinové předpovědi aktualizované osmkrát denně, do 84 hodin u čtyř hlavních běhů a 18 hodin u ostatních.",
  "common.forecastModelDescription_RRFS_NORTH_AMERICA": "Systém Rapid Refresh Forecast od NOAA pokrývající celou Severní Ameriku s rozlišením 13 km. Hodinové předpovědi do 84 hodin, aktualizované čtyřikrát denně.",
  "common.forecastModelDescription_SMARTMIXIN_MULTIMODEL": "Vlajková předpověď SmartMixin. Pro každou hodinu na vašem místě vybíráme nejlepší dostupný model — obvykle vysokorozlišovací regionální model tam, kde existuje (AROME ve Francii, ICON-D2 v Německu, HRRR v USA, ARPEGE Europe napříč kontinentem…) a jinde se vracíme ke globálnímu modelu — poté zaplníme veškeré mezery ze sousedních zdrojů. Výsledkem je jediná bezproblémová předpověď pokrývající kdekoli na světě až 14 dní, automaticky aktualizovaná vždy, když je jeden z podkladových modelů aktualizován.",
  "common.forecastModelDescription_WEATHERFLOW_FORECAST": "Vlastní globální předpověď Weatherflow, která kombinuje více numerických modelů počasí s pozorováními ze sítě meteorologických stanic Tempest. Celosvětový 10denní horizont.",
  "common.forecastModelDetailTitle": "Předpovědní model",
  "common.forecastModelScopeGlobal": "Globální",
  "common.forecastModelScopeGlobalDescription": "Tento model pokrývá celou planetu.",
  "common.forecastModelScopeRegional": "Regionální",
  "common.forecastModelScopeRegionalDescription": "Tento model pokrývá pouze určitý region.",
  "common.forecastModelSpecifications": "Specifikace",
  "common.forecastNoPinLocation": "Na tuto polohu nedosáhne žádný preferovaný model — rozhoduje „všude jinde“.",
  "common.forecastNoPinStation": "Na tuto stanici nedosáhne žádný preferovaný model — rozhoduje „všude jinde“.",
  "common.forecastNoPreferredModels": "Zatím nejsou nastaveny žádné preferované modely.",
  "common.forecastOverrideElsewhere": "Vaše předvolby platí všude jinde.",
  "common.forecastPickForLocation": "Nebo vyberte jeden pro tuto polohu",
  "common.forecastPickForStation": "Nebo vyberte jeden pro tuto stanici",
  "common.forecastPinWinsLocation": "{model} — váš první preferovaný model, který dosáhne na tuto polohu.",
  "common.forecastPinWinsStation": "{model} — váš první preferovaný model, který dosáhne na tuto stanici.",
  "common.forecastServedNowHere": "Právě teď je to zde {model}",
  "common.forecastSetForLocation": "Nastaveno pro tuto polohu",
  "common.forecastSetForStation": "Nastaveno pro tuto stanici",
  "common.forecastSettingsRowSub": "Preferované modely a co platí všude jinde",
  "common.forecastSheetTitle": "Model předpovědi",
  "common.forecastSources": "Zdroje předpovědi",
  "common.forecastStopUsingHere": "Zde už nepoužívat",
  "common.forecastUseForLocation": "Použít {model} pro tuto polohu",
  "common.forecastUseForStation": "Použít {model} pro tuto stanici",
  "common.forecastUsePreferred": "Použít mé preferované modely",
  "common.freeAccount": "Účet zdarma",
  "common.freeSubscription": "Předplatné zdarma",
  "common.freeTrialForPeriod": "Bezplatná zkušební verze pro {period} dny",
  "common.frequency": "Frekvence",
  "common.full": "Plný",
  "common.fullscreen": "Celá obrazovka",
  "common.getStartedFree": "Začít Zdarma",
  "common.getUnlimitedAccess": "Neomezený přístup k:",
  "common.good": "Dobrý",
  "common.hail": "Kroupy",
  "common.help": "Nápověda",
  "common.helpCategoryAccount": "Účet",
  "common.helpCategoryBilling": "Fakturace",
  "common.helpCategoryForecast": "Předpovědi",
  "common.helpCategoryGettingStarted": "Začínáme",
  "common.helpCategoryProviders": "Poskytovatelé",
  "common.helpCategoryStations": "Stanice",
  "common.helpCategoryTroubleshooting": "Řešení problémů",
  "common.helpCenter": "Centrum nápovědy",
  "common.helpCenterDescription": "Najděte odpovědi na časté otázky a zjistěte, jak co nejlépe využít SmartMixin.",
  "common.hg": "Protimrazová ochrana",
  "common.hidden": "Skryté",
  "common.hiddenSensors": "Skryté senzory",
  "common.hiddenStations": "Skryté stanice",
  "common.hiddenStationsDescription": "Stanici můžete vyladit klepnutím na ikonu oka vedle ní.",
  "common.high": "Vysoká",
  "common.home": "Domů",
  "common.homeConnectService": "Vlastníte meteostanici? Připojte svou službu",
  "common.homeInformation": "Domácí informace",
  "common.homeIntroduction": "Začněte připojovat své externí účty, abyste si mohli užívat funkce SmartMixin.",
  "common.homeName": "Domovské jméno",
  "common.homeSubtitle": "Vaše počasí, vše na jednom místě",
  "common.horizon": "Horizont",
  "common.horizonValue": "až {value} hodin",
  "common.hour": "Hodina",
  "common.iDontKnowYet": "Ještě nevím",
  "common.indoor": "Uvnitř",
  "common.lastRainEvent": "Poslední dešťová akce",
  "common.lastSeen": "naposledy {time}",
  "common.lastUpdate": "Poslední aktualizace",
  "common.legendHeavy": "Silné",
  "common.legendLight": "Slabé",
  "common.legendLightningHelp": "Barva ukazuje stáří každého blesku za posledních {minutes} minut — nejnovější bíle, nejstarší tmavě červeně.",
  "common.legendNewest": "Nejnovější",
  "common.legendOldest": "Nejstarší",
  "common.legendStationsHelp": "Barva značky odráží hodnotu vybrané veličiny.",
  "common.lightningDataAttribution": "Data o blescích: Blitzortung.org",
  "common.lightningStrikes": "Údery blesků",
  "common.lightningStrikesDescription": "Zobrazit údery blesků v reálném čase na mapě",
  "common.linkToSection": "Odkaz na tuto sekci",
  "common.loading": "Načítání",
  "common.location": "Poloha",
  "common.locationAddedToFavorites": "Poloha přidána k oblíbeným",
  "common.locationNotGranted": "Povolení k poloze se neposkytuje. Povolte prosím přístup k vaší poloze v nastavení zařízení.",
  "common.locationRemovedFromFavorites": "Místo odstraněno z oblíbených",
  "common.locations": "Polohy",
  "common.low": "Nízká",
  "common.manage": "Spravovat",
  "common.manageAccount": "Spravovat účet",
  "common.manageMySubscription": "Spravovat mé předplatné",
  "common.manageSensors": "Správa senzorů",
  "common.manageSensorsDescription": "Přetáhněte položky pro změnu pořadí senzorů. Klepněte na ikonu oka pro zobrazení nebo skrytí senzorů. Klepněte na název pro jeho přejmenování.",
  "common.manualBoost": "Ruční zvýšení",
  "common.manualSetpointUntil": "Ruční nastavení do",
  "common.mapLayers": "Vrstvy mapy",
  "common.mapLegend": "Legenda mapy",
  "common.maxFavoriteLocationsReached": "Můžete mít pouze 5 oblíbených míst. Odstraňte jeden a přidejte další.",
  "common.maximum": "Maximum",
  "common.maxOverThePeriod": "Maximum za období",
  "common.measureToDisplay": "Změřte pro zobrazení",
  "common.medium": "Střední",
  "common.meshSize": "Velikost mřížky",
  "common.minimum": "Minimum",
  "common.minRead": "{minutes} min čtení",
  "common.modifyFavoriteStations": "Upravit oblíbené stanice",
  "common.modifyFavoriteStationsDescription": "Jejich oblíbené stanice si můžete přetáhnout jejich přetažením. Můžete je také odstranit ze seznamu.",
  "common.moduleCount": "{count, plural, one {# modul} few {# moduly} many {# modulu} other {# modulů}}",
  "common.moduleType": "Typ modulu",
  "common.monthTotal": "Tento měsíc",
  "common.more": "Více",
  "common.moreInformation": "Více informací",
  "common.morning": "Ráno",
  "common.myLocation": "Moje poloha",
  "common.nearbyWeatherStations": "Blízké povětrnostní stanice",
  "common.next": "Další",
  "common.nextHours": "Další hodiny",
  "common.night": "Noc",
  "common.no": "Ne",
  "common.noAccountNeeded": "Bez nutnosti účtu",
  "common.noDataForThisPeriod": "Pro toto období nejsou dostupná data",
  "common.noLocationsFound": "Žádná místa nenalezena",
  "common.noNetatmoWeatherStationYet": "Prozatím nevlastníte meteostanici Netatmo.",
  "common.noOutdoorModule": "Pro tuto stanici neexistuje funkční venkovní modul.",
  "common.noSearchResults": "Vašemu hledání neodpovídají žádné články",
  "common.noStationsFound": "Žádné stanice nenalezeny",
  "common.noThermostatYet": "Prozatím nevlastníte termostat.",
  "common.notNow": "Ne teď",
  "common.notPurchasedYet": "Zdá se, že verzi Pro nemáte ještě zakoupenou.",
  "common.notReachable": "Nedostupné",
  "common.now": "Nyní",
  "common.noWeatherStation": "Žádná meteostanice",
  "common.noWeatherStationYet": "Prozatím nevlastníte meteostanici.",
  "common.numberOfActiveWarnings": "{warning_count} aktivní varování počasí",
  "common.onThisPage": "Na této stránce",
  "common.openSettings": "Otevřené nastavení",
  "common.orChooseMonthly": "Nebo zvolte měsíčně:",
  "common.outdoor": "Venku",
  "common.outdoorTemperature": "Venkovní teplota",
  "common.pageNotFound": "Stránka Nenalezena",
  "common.pageNotFoundDescription": "Stránka, kterou hledáte, neexistuje nebo byla přesunuta.",
  "common.passwordUpdated": "Heslo úspěšně aktualizováno.",
  "common.personalWeatherIntelligence": "Vaše Osobní Meteorologická Inteligence",
  "common.platformMobileApp": "Mobilní aplikace",
  "common.platformMobileOnly": "Pouze v mobilní aplikaci",
  "common.platformWebApp": "Webová aplikace",
  "common.platformWebOnly": "Pouze ve webové aplikaci",
  "common.popularArticles": "Oblíbené články",
  "common.premiumAccount": "Prémiový účet",
  "common.premiumDescription": "Prémiové předplatné odemkne celou řadu dalších funkcí, jako je pokročilá analýza počasí, srovnání map, regionální předpovědní modely a mnoho dalšího.",
  "common.premiumFeatureAlerts": "Povětrnostní Výstrahy",
  "common.premiumFeatureAnalysis": "Pokročilá Analýza Počasí",
  "common.premiumFeatureCharts": "Porovnání Grafů",
  "common.premiumFeatureExport": "Export Dat",
  "common.premiumFeatureForecast": "Regionální Předpovědní Modely",
  "common.premiumFeatureNotification": "Widget Stavového Řádku",
  "common.premiumFeatureTitle": "Prémiová Funkce",
  "common.premiumFeatureWidgets": "Widgety domovské obrazovky",
  "common.pressureSummary": "Souhrn tlaku",
  "common.previous": "Předchozí",
  "common.previousHours": "Předchozí hodiny",
  "common.profileUpdated": "Profil byl úspěšně aktualizován.",
  "common.purchasedNetatmoPro": "Dříve jste zakoupili Netatmo Pro ({date}). Přihlaste se k odběru jedné z níže uvedených nabídek a získejte přístup ke všem prémiovým funkcím aplikace.",
  "common.radarDataAttribution": "Data z radaru: NOAA / EUMETNET OPERA via LibreWXR",
  "common.rain": "Srážky",
  "common.rainEvents": "Dešťové události",
  "common.rainfallMeasurement": "Měření srážek",
  "common.rainRadar": "Dešťový radar",
  "common.rainRadarDescription": "Zobrazte na mapě překrytí dešťového radaru",
  "common.rainSummary": "Souhrn srážek",
  "common.range": "Období",
  "common.recentLocations": "Nedávné",
  "common.recentLocationsEmpty": "Nedávná historie je prázdná.",
  "common.recentStations": "Nedávné stanice",
  "common.relatedArticles": "Související články",
  "common.relay": "Relé",
  "common.removeFromFavorites": "Smazat z oblíbených",
  "common.renameSensors": "Přejmenování senzorů",
  "common.resetZoom": "Obnovit přiblížení",
  "common.restorePurchase": "Obnovit nákup",
  "common.room": "Pokoj",
  "common.rooms": "Pokoje",
  "common.savingsPercent": "Ušetříte {percent}%",
  "common.searchArticles": "Hledat články...",
  "common.searchForALocation": "Hledat místo...",
  "common.searchForLocation": "Vyhledat misto",
  "common.searchForWeatherStation": "Vyhledat meteostanici",
  "common.searchResults": "Výsledky vyhledávání",
  "common.searchResultsEmpty": "Nebyly nalezeny žádné výsledky.",
  "common.searchResultsFound": "{count, plural, one {Nalezen # výsledek} few {Nalezeny # výsledky} many {Nalezeno # výsledku} other {Nalezeno # výsledků}}",
  "common.searchStationsDescription": "Zadejte město, adresu nebo název místa pro nalezení meteorologických stanic v okolí.",
  "common.searchStationsHint": "Použijte vyhledávací pole výše k objevení meteorologických stanic kdekoli na světě.",
  "common.selectStationForComparison": "Vyberte stanici pro srovnění",
  "common.selectWeatherForecastProvider": "Vyberte poskytovatele počasí",
  "common.serialNumber": "Sériové číslo",
  "common.share": "Sdílet",
  "common.shareOutdoorMeasures": "Sdílet mé venkovní měření",
  "common.shareOutdoorMeasuresDescription": "Zapojte se do komunity SmartMixin sdílením svých externích dat. Data vnitřního modulu nebudou nikdy sdílena.",
  "common.shareYourWeather": "Podělte se o své počasí",
  "common.signalAverage": "Střední",
  "common.signalBad": "Slabý",
  "common.signalGood": "Dobrý",
  "common.signalStrength": "Síla signálu",
  "common.signalUnknown": "Neznámý",
  "common.skip": "Přeskočit",
  "common.smartThermostat": "Chytrý termostat",
  "common.smartValve": "Inteligentní ventil",
  "common.snow": "Sníh",
  "common.start": "Start",
  "common.startFreeTrial": "Zahájit Bezplatnou Zkušební Verzi",
  "common.startTime": "Začátek",
  "common.station": "stanice",
  "common.stationAddedToFavorites": "Meteostanice přidána do oblíbených",
  "common.stationComparison": "Srovnání stanic",
  "common.stationComparisonDescription": "Umožňuje porovnat historické údaje o počasí s údaji jiné stanice.",
  "common.stationInformation": "Informace o stanici",
  "common.stationName": "Název stanice",
  "common.stationObservationsDescription": "Zobrazte nejnovější pozorování z meteorologických stanic",
  "common.stationRemovedFromFavorites": "Meteostanice smazána z oblíbených",
  "common.stations": "stanice",
  "common.stationsNear": "Stanice poblíž",
  "common.stationType": "typ stanice",
  "common.statusOffline": "Offline",
  "common.statusOnline": "Online",
  "common.statusStale": "Zastaralé",
  "common.statusSyncing": "Synchronizace",
  "common.stillNeedHelp": "Stále potřebujete pomoc?",
  "common.stillNeedHelpDescription": "Pokud tento článek nezodpověděl vaši otázku, rád vám pomohu osobně.",
  "common.subscribeNow": "Předplatit nyní - bez zkušební doby",
  "common.sumOverThePeriod": "Kumulované za období",
  "common.switchToPremium": "Přepnout na SmartMixin Premium",
  "common.temperatureShort": "Tepl.",
  "common.temperatureSummary": "Souhrn teploty",
  "common.thankYouForFeedback": "Děkujeme za vaši zpětnou vazbu!",
  "common.thenPrice": "poté {price}",
  "common.timeSelection": "Výběr času",
  "common.timezone": "Časové pásmo",
  "common.totalDuration": "Celková doba trvání",
  "common.tryAnotherLocation": "Nepodařilo se nám najít žádné meteorologické stanice v blízkosti tohoto místa. Zkuste hledat v jiné oblasti.",
  "common.unknown": "Neznámý",
  "common.untilChanged": "Dokud se nezmění",
  "common.untilTime": "Do {time}",
  "common.updateAvailable": "Je k dispozici aktualizace",
  "common.updateAvailableOpenAppStore": "Klepnutím otevřete App Store",
  "common.updateAvailableOpenGooglePlay": "Klepnutím otevřete Google Play",
  "common.updateAvailableVersion": "Je k dispozici aktualizace: v{version}",
  "common.upgrade": "Upgrade",
  "common.upgradeRequiredAndroid": "Je vyžadována aktualizace vaší aplikace, upgradujte v Google Play.",
  "common.upgradeRequiredIos": "Je vyžadována aktualizace vaší aplikace, upgradujte v obchodě s aplikacemi.",
  "common.validate": "Schválit",
  "common.validEmail": "Je vyžadována platná e-mailová adresa.",
  "common.very_low": "Velmi nízké",
  "common.viewAsList": "Seznam",
  "common.viewAsPeriods": "Části dne",
  "common.visitNetatmoWebsite": "Navštivte webové stránky Netatmo",
  "common.wasArticleHelpful": "Byl tento článek užitečný?",
  "common.weatherCondition": "Počasí",
  "common.weatherflowNCRain": "NC Rain (Nearcast Rain)",
  "common.weatherflowNCRainDescription": "NC Rain je další zdroj dat poskytovaný prostřednictvím systému Tempest Weather System s technologií Nearcast. Data NC Rain jsou odhadem průměrné akumulace srážek kolem vašeho Tempest na úrovni sousedství",
  "common.weatherForecastModels": "Modely předpovědi počasí",
  "common.weatherIntelligencePlatform": "Platforma Meteorologické Inteligence",
  "common.weatherMap": "Mapa počasí",
  "common.weatherMapMetaDescription": "SmartMixin nabízí interaktivní mapy počasí a radaru pro povětrnostní podmínky po celém světě.",
  "common.weatherObservations": "Pozorování počasí",
  "common.weatherStation": "Meteorologická stanice",
  "common.weatherStations": "Meteorologické stanice",
  "common.welcome": "Vítejte v SmartMixin!",
  "common.whenBackHome": "Kdy se vrátíš domů?",
  "common.wifiStrength": "síla WiFi",
  "common.wind": "Vítr",
  "common.windMeasurement": "Měření větru",
  "common.windSpeed": "Rychlost větru",
  "common.windSummary": "Souhrn větru",
  "common.yearToDate": "Tento rok",
  "common.yes": "Ano",
  "common.zoomImage": "Přiblížit obrázek",
  "forecastMaps.addColor": "Přidat barvu",
  "forecastMaps.addLayer": "Přidat vrstvu",
  "forecastMaps.autoPreview": "Auto",
  "forecastMaps.backToMaps": "Zpět na mapy",
  "forecastMaps.browseMaps": "Procházet mapy",
  "forecastMaps.build": "Vygenerovat",
  "forecastMaps.buildCompleted": "Generování dokončeno",
  "forecastMaps.builderMetaDescription": "Sestavte si vlastní předpovědní mapy z vrstev meteorologických modelů.",
  "forecastMaps.builderTitle": "Tvůrce map",
  "forecastMaps.buildFailed": "Generování se nezdařilo. Zkuste to znovu.",
  "forecastMaps.buildNotPossible": "Tuto mapu zatím nelze vygenerovat — nejsou k dispozici žádná předpovědní data.",
  "forecastMaps.buildProgress": "Vykreslování… {completed}/{total} kroků",
  "forecastMaps.buildStarting": "Spouštění generování…",
  "forecastMaps.byModel": "Podle modelu",
  "forecastMaps.byZone": "Podle zóny",
  "forecastMaps.colormap": "Barevná škála",
  "forecastMaps.colormapCustom": "Vlastní barvy",
  "forecastMaps.colormapGroupDomain": "Meteorologické předvolby",
  "forecastMaps.colormapGroupMatplotlib": "Vědecké předvolby",
  "forecastMaps.colorScale": "Barevná škála",
  "forecastMaps.comingSoon": "Toto zobrazení bude brzy k dispozici.",
  "forecastMaps.contourLevels": "Úrovně izolinií",
  "forecastMaps.countryCanada": "Kanada",
  "forecastMaps.countryFrance": "Francie",
  "forecastMaps.countryGermany": "Německo",
  "forecastMaps.countryItaly": "Itálie",
  "forecastMaps.countryScandinavia": "Skandinávie",
  "forecastMaps.countrySpain": "Španělsko",
  "forecastMaps.countrySwitzerland": "Švýcarsko",
  "forecastMaps.countryUnitedStates": "Spojené státy",
  "forecastMaps.customColormapMinColors": "Vlastní barevná škála vyžaduje alespoň dvě barvy",
  "forecastMaps.customExtent": "Vlastní výřez",
  "forecastMaps.deleteMap": "Smazat mapu",
  "forecastMaps.deleteMapBody": "„{name}“ a její vykreslené běhy budou trvale smazány.",
  "forecastMaps.deleteMapTitle": "Smazat tuto mapu?",
  "forecastMaps.displayName": "Zobrazovaný název",
  "forecastMaps.downloadMp4": "Stáhnout MP4",
  "forecastMaps.downscaling": "Faktor ředění větrných praporků",
  "forecastMaps.dpi": "DPI",
  "forecastMaps.drawArea": "Nakreslit oblast",
  "forecastMaps.east": "Východ",
  "forecastMaps.editMap": "Upravit mapu",
  "forecastMaps.exportBuilding": "Připravuje se video…",
  "forecastMaps.exportError": "Export videa se nezdařil. Zkuste to znovu.",
  "forecastMaps.exportMp4": "Exportovat MP4",
  "forecastMaps.exportNotReady": "Video ještě není připraveno. Zkuste to později.",
  "forecastMaps.extentDrawHint": "Tažením po mapě nakreslete oblast",
  "forecastMaps.extentInvalid": "Západ musí být menší než východ a jih menší než sever",
  "forecastMaps.extentPanZoomHint": "Posouvejte a přibližujte, dokud oblast nevyplní rámec",
  "forecastMaps.flipbookView": "Animace",
  "forecastMaps.forecastModel": "Předpovědní model",
  "forecastMaps.forkAndEdit": "Duplikovat a upravit",
  "forecastMaps.height": "Výška (palce)",
  "forecastMaps.hourOffset": "+{hour} h",
  "forecastMaps.invalidHexColor": "Neplatná barva — použijte #RRGGBB",
  "forecastMaps.layers": "Vrstvy",
  "forecastMaps.layerTypeBarbs": "Větrné praporky",
  "forecastMaps.layerTypeContour": "Izolinie",
  "forecastMaps.layerTypeFilledContour": "Vyplněné izolinie",
  "forecastMaps.layerTypeMagnitude": "Velikost",
  "forecastMaps.layerTypeRaster": "Rastr",
  "forecastMaps.layerTypeVectorField": "Vektorové pole",
  "forecastMaps.leave": "Odejít",
  "forecastMaps.levelsCount": "Počet",
  "forecastMaps.levelsInvalid": "Neplatné úrovně izolinií",
  "forecastMaps.levelsModeArange": "Pevný krok",
  "forecastMaps.levelsModeExplicit": "Explicitní hodnoty",
  "forecastMaps.levelsModeLinspace": "Rovnoměrně rozložené (počet)",
  "forecastMaps.levelsStep": "Krok",
  "forecastMaps.levelsValues": "Hodnoty",
  "forecastMaps.levelsValuesHint": "Oddělené čárkami, vzestupně",
  "forecastMaps.localTimeHint": "Zobrazeno v místním čase",
  "forecastMaps.map": "Mapa",
  "forecastMaps.mapDescription": "Popis",
  "forecastMaps.mapName": "Název mapy",
  "forecastMaps.mapNameRequired": "Zadejte název",
  "forecastMaps.mapSettings": "Nastavení mapy",
  "forecastMaps.mapView": "Interaktivní mapa",
  "forecastMaps.maxLayersReached": "Tato mapa dosáhla maxima {max} vrstev.",
  "forecastMaps.maxValue": "Maximální hodnota",
  "forecastMaps.memoryBudgetExceeded": "Rozlišení překračuje limit vykreslování — snižte DPI nebo výšku",
  "forecastMaps.memoryBudgetUsage": "Limit vykreslování: {percent}%",
  "forecastMaps.metaDescription": "Animované předpovědní mapy vytvořené z běhů meteorologických modelů.",
  "forecastMaps.metric": "Veličina",
  "forecastMaps.metricRequired": "Vyberte veličinu",
  "forecastMaps.metricUnavailable": "Pro tento model není k dispozici",
  "forecastMaps.minBelowMax": "Minimum musí být menší než maximum",
  "forecastMaps.minMaxRequired": "Minimální a maximální hodnoty jsou pro tento typ vrstvy povinné",
  "forecastMaps.minValue": "Minimální hodnota",
  "forecastMaps.modelNoRun": "Zatím žádný dokončený běh",
  "forecastMaps.moveLayerDown": "Posunout dolů",
  "forecastMaps.moveLayerUp": "Posunout nahoru",
  "forecastMaps.myMaps": "Moje mapy",
  "forecastMaps.nanClipToMin": "Omezit na minimum",
  "forecastMaps.nanMask": "Maskovat",
  "forecastMaps.nanPolicy": "Chybějící data",
  "forecastMaps.nanSkip": "Přeskočit",
  "forecastMaps.newMap": "Nová mapa",
  "forecastMaps.noCompletedRun": "Tato mapa zatím nebyla vytvořena. Zkuste to prosím později.",
  "forecastMaps.noLayers": "Zatím žádné vrstvy. Začněte přidáním vrstvy.",
  "forecastMaps.noMapsAvailable": "Zatím nejsou k dispozici žádné předpovědní mapy.",
  "forecastMaps.north": "Sever",
  "forecastMaps.opacity": "Průhlednost",
  "forecastMaps.overlayLegend": "Legenda",
  "forecastMaps.pause": "Pozastavit",
  "forecastMaps.play": "Přehrát",
  "forecastMaps.pointValueError": "Předpověď pro tento bod se nepodařilo načíst.",
  "forecastMaps.pointValueLoading": "Načítání předpovědi…",
  "forecastMaps.pointValueUnavailable": "Pro tento čas nejsou k dispozici žádná data.",
  "forecastMaps.presets": "Předvolby",
  "forecastMaps.preview": "Náhled",
  "forecastMaps.previewEmptyHint": "Pro vykreslení náhledu nastavte alespoň jednu platnou vrstvu.",
  "forecastMaps.previewFailed": "Náhled se nezdařil",
  "forecastMaps.previewHour": "Hodina předpovědi",
  "forecastMaps.previewRendering": "Vykreslování náhledu…",
  "forecastMaps.projection": "Projekce",
  "forecastMaps.projectionLambertConformal": "Lambertova konformní",
  "forecastMaps.projectionMercator": "Mercatorova",
  "forecastMaps.projectionPlateCarree": "Plate carrée",
  "forecastMaps.projectionStereographic": "Stereografická",
  "forecastMaps.regionEurope": "Evropa",
  "forecastMaps.regionNorthAmerica": "Severní Amerika",
  "forecastMaps.removeColor": "Odebrat barvu",
  "forecastMaps.removeLayer": "Odebrat vrstvu",
  "forecastMaps.retry": "Zkusit znovu",
  "forecastMaps.run": "Běh: {run}",
  "forecastMaps.save": "Uložit",
  "forecastMaps.selectExtentOnMap": "Vybrat oblast na mapě",
  "forecastMaps.south": "Jih",
  "forecastMaps.title": "Předpovědní mapy",
  "forecastMaps.uMetric": "Složka U",
  "forecastMaps.unitConversion": "Převod jednotek",
  "forecastMaps.unitNone": "Žádný",
  "forecastMaps.unsavedChangesBody": "Máte neuložené změny. Odejít a zahodit je?",
  "forecastMaps.unsavedChangesTitle": "Neuložené změny",
  "forecastMaps.useCurrentView": "Použít aktuální zobrazení",
  "forecastMaps.useModelDomain": "Vypnuto: použije se celá oblast modelu",
  "forecastMaps.utcTime": "UTC: {time}",
  "forecastMaps.uvMetricsDiffer": "Veličiny U a V se musí lišit",
  "forecastMaps.validTime": "Platnost: {time}",
  "forecastMaps.valueBetween": "Musí být mezi {min} a {max}",
  "forecastMaps.variable": "Veličina",
  "forecastMaps.viewMap": "Zobrazit mapu",
  "forecastMaps.vMetric": "Složka V",
  "forecastMaps.west": "Západ",
  "forecastMaps.windAnimation": "Animace větru",
  "intro.locationDescription": "Povolte přístup k lokaci pro přesné předpovědi šité na míru vaší přesné oblasti — žádné univerzální předpovědi.",
  "intro.locationTitle": "Předpovědi vytvořené pro vás",
  "intro.notificationDescription": "Zapněte oznámení pro včasná upozornění o změnách počasí, na kterých vám záleží — déšť, sníh nebo extrémní podmínky, právě kdy je to potřeba.",
  "intro.notificationsTitle": "Nepropásněte žádnou změnu počasí",
  "intro.readyDescription": "Užijte si přesné předpovědi, aktuální meteorologické informace a data ze stanic po celém světě — vše v jedné výkonné aplikaci.",
  "intro.readyTitle": "Vše je připraveno!",
  "intro.welcomeDescription": "Získejte hyperlokální předpovědi od předních meteorologických agentur — navíc přístup k více než 40 000 meteorologickým stanicím po celém světě pro reálné podmínky, jak aktuální, tak historické.",
  "intro.welcomeTitle": "Vaše počasí, znovu promyšlené",
  "landing.alerts": "Upozornění",
  "landing.alertsDescription": "Vytvořte si vlastní upozornění a získejte upozornění, jakmile se spustí.",
  "landing.featureAlertsDescription": "Nastavte si vlastní upozornění pro podmínky, které vás zajímají—teplota, vítr, srážky a další.",
  "landing.featureAlertsTitle": "Chytré upozornění",
  "landing.featureAnalyticsDescription": "Ponořte se do svých dat pomocí interaktivních grafů, srovnění vedle sebe a analýzy trendů přesahující základní metriky.",
  "landing.featureAnalyticsTitle": "Výkonná analytika",
  "landing.featureExportDescription": "Stáhněte si svá data ve formátu CSV pro analýzu v Excelu, integraci s jinými systémy nebo zálohu.",
  "landing.featureExportTitle": "Export kamkoli",
  "landing.featureForecastDescription": "Porovnejte předpovědi z více než 10 meteorologických modelů včetně GFS, ECMWF, ICON a dalších, abyste viděli, který funguje nejlépe pro vaši lokalitu.",
  "landing.featureForecastTitle": "Porovnání předpovědí",
  "landing.featureHistoryDescription": "Přístup k historickým datům v hodinovém, denním a měsíčním měřítku. Export do CSV pro výzkum nebo osobní archivy.",
  "landing.featureHistoryTitle": "Bohatá historie",
  "landing.featureMultiBrandDescription": "Připojte stanice od Netatmo, Ecowitt, Ambient Weather, Davis, WeatherFlow a dalších—vše v jednom dashboardu.",
  "landing.featureMultiBrandTitle": "Podpora více značek",
  "landing.featuresSubtitle": "Navrženo pro nadšence do počasí, kteří vyžadují více než základní aplikaci meteorologické stanice.",
  "landing.featuresTitle": "Vše, co potřebujete k analýze počasí",
  "landing.finalCtaButton": "Vytvořit účet zdarma",
  "landing.finalCtaSubtitle": "Připojte se k tisícům nadšenců do počasí, kteří důvěřují SmartMixinu se svými meteorologickými daty.",
  "landing.finalCtaTitle": "Připraveni vylepšit své počasí?",
  "landing.forecastDescription": "Získejte přístup k některým z nejlepších modelů předpovědi počasí a porovnejte je, abyste získali vlastní představu o tom, jaké bude počasí.",
  "landing.forecasts": "Předpovědi",
  "landing.heroCta": "Začít zdarma",
  "landing.heroDescription": "Spojte více meteorologických stanic libovolné značky, porovnávejte předpovědní modely a analyzujte svá data pomocí podrobných grafů a exportů.",
  "landing.heroSecondaryCta": "Zobrazit funkce",
  "landing.heroTagline": "Pro nadšence do počasí",
  "landing.heroTitle": "Všechna meteorologická data. Jedna platforma.",
  "landing.pricingFeatureAdvancedMetrics": "Pokročilé metriky",
  "landing.pricingFeatureAlerts": "Vlastní upozornění",
  "landing.pricingFeatureExport": "Export dat (CSV)",
  "landing.pricingFeatureForecastComparison": "Porovnání předpovědí",
  "landing.pricingFeatureForecasts": "Předpovědní modely",
  "landing.pricingFeatureForecastsFreeTier": "1 model",
  "landing.pricingFeatureForecastsPremiumTier": "Všechny modely (10+)",
  "landing.pricingFeatureReports": "Analýzy a reporty",
  "landing.pricingFeatureStationComparison": "Porovnání stanic",
  "landing.pricingFeatureWidgets": "Widgety na domovské obrazovce",
  "landing.pricingFeatureYearOverYear": "Meziroční analýza",
  "landing.pricingFree": "Zdarma",
  "landing.pricingFreeCta": "Začít",
  "landing.pricingFreePrice": "0 €",
  "landing.pricingMostPopular": "Nejoblíbenější",
  "landing.pricingPremium": "Premium",
  "landing.pricingPremiumCta": "Začít",
  "landing.pricingPremiumDescription": "Od 1,99 €/měsíc — předplaťte si na webu, App Store nebo Google Play",
  "landing.pricingSubtitle": "Začněte zdarma, upgradujte když potřebujete více.",
  "landing.pricingTitle": "Jednoduchý, transparentní ceník",
  "landing.smartMixinDescription": "SmartMixin je aplikace, která poskytuje přístup k vaší meteostanici a více než 40 tisícům dalších stanic po celém světě. Pomáhá vám vidět a porozumět údajům o počasí.",
  "landing.statBrands": "Podporované značky",
  "landing.statForecasts": "Předpovědních modelů",
  "landing.statStations": "Připojených stanic",
  "landing.supportedDevices": "Podporovaná zařízení",
  "landing.supportedDevicesDescription": "Kromě stanic Světové meteorologické organizace podporuje SmartMixin rostoucí počet značek meteorologických stanic.",
  "landing.supportedDevicesNote": "Plus více než 40 000 veřejných stanic Světové meteorologické organizace",
  "landing.supportedDevicesSubtitle": "Připojte meteorologické stanice předních značek a zobrazte všechna data na jednom místě.",
  "landing.supportedDevicesTitle": "Funguje s vašimi stanicemi",
  "landing.thermostatDescription": "Připojte svůj termostat Netatmo a porovnávejte vzorce vytápění s venkovními podmínkami.",
  "landing.thermostatManufacturers": "Výrobci termostatů jsou také podporováni, aby korelovali vytápění s venkovními podmínkami.",
  "landing.thermostatTitle": "Integrace s chytrou domácností",
  "landing.weatherAnalysis": "Analýza počasí",
  "landing.weatherAnalysisDescription": "SmartMix přichází se spoustou vizualizace dat, která vám umožní analyzovat data o počasí.",
  "landing.weatherAssistant": "Váš asistent počasí",
  "landing.weatherAssistantDescription": "Ať už vás zajímají aktuální, historické nebo předpovědní povětrnostní podmínky, SmartMixin poskytuje četné informace, kdykoli je potřebujete.",
  "landing.weatherForecastModels": "Modely předpovědi počasí",
  "landing.weatherForecastModelsDescription": "SmartMixin poskytuje přístup k nejpřesnějším modelům předpovědi počasí. Jejich předpovědi si můžete snadno porovnat a udělat si vlastní představu.",
  "landing.weatherMap": "Mapa počasí",
  "landing.weatherMapDescription": "Procházejte mapu a představte si, jaké je počasí kdekoli na světě.",
  "network.cancelError": "Požadavek byl odmínut",
  "network.connectionError": "Server není dostupný",
  "network.networkError": "Síť není dostupná",
  "network.serverError": "Něco se pokazilo...",
  "network.timeoutError": "Časový limit spojení vypršel",
  "network.unknownError": "Neznámá chyba",
  "providerHints.ambientWeatherApiKey": "Vytvořeno v nastavení vašeho účtu na ambientweather.net.",
  "providerHints.davisApiSecret": "Zobrazí se pouze jednou při vytvoření V2 API klíče — uchovejte v bezpečí.",
  "providerHints.davisV2ApiKey": "Ze stránky V2 API klíčů na weatherlink.com.",
  "providerHints.ecowittApi": "Ze stránky API vašeho účtu Ecowitt.",
  "providerHints.ecowittApp": "Klíč aplikace, také z vašeho účtu Ecowitt.",
  "providerHints.myAcuriteCredentialsBanner": "Použijte e-mail a heslo vašeho účtu My AcuRite — nikoli přihlášení do SmartMixin.",
  "providerHints.myAcuriteEmail": "E-mail vašeho účtu My AcuRite — nikoli vaše přihlášení do SmartMixin.",
  "providerHints.myAcuritePassword": "Heslo vašeho účtu My AcuRite.",
  "providerHints.weatherflowToken": "Osobní token z tempestwx.com → nastavení → autorizace dat.",
  "providerHints.wundergroundEditKey": "Použít jiný klíč",
  "providerHints.wundergroundKey": "Dlouhý řetězec ze stránky API klíčů vašeho účtu Weather Underground — nikoli vaše heslo na wunderground.com.",
  "providerHints.wundergroundKeyExample": "např. 5f6a7b8c9dabcdef…",
  "providerHints.wundergroundKeyVerified": "API klíč ověřen",
  "providerHints.wundergroundKeyVerifying": "Ověřování klíče…",
  "providerHints.wundergroundNoStationsNearby": "V okolí této lokality nebyly nalezeny žádné stanice. Zkuste zadat ID stanice přímo.",
  "providerHints.wundergroundStationId": "Jakékoliv ID stanice Weather Underground — vaše vlastní nebo veřejná stanice ve vašem okolí.",
  "providerHints.wundergroundStationIdExample": "např. KCASANFR123",
  "providerIntro.ambientWeatherStep2": "Získejte svůj API klíč Ambient Weather.",
  "providerIntro.davisStep2": "Získejte svůj V2 API klíč a API tajemství Davis.",
  "providerIntro.ecowittStep2": "Získejte svůj API klíč a klíč aplikace Ecowitt.",
  "providerIntro.getStarted": "Začít",
  "providerIntro.myAcuriteStep2": "Použijte e-mail a heslo vašeho stávajícího účtu My AcuRite.",
  "providerIntro.netatmoEnergyStep2": "Přihlaste se k Netatmo, když budete vyzváni — API klíč není potřeba.",
  "providerIntro.netatmoWeatherStep2": "Přihlaste se k Netatmo, když budete vyzváni — API klíč není potřeba.",
  "providerIntro.signupBanner": "Téměř hotovo — vytvořte si bezplatný účet SmartMixin pro připojení {provider}.",
  "providerIntro.step1": "Přihlaste se ke svému účtu SmartMixin (NIKOLIV k {provider}).",
  "providerIntro.step3EmailPassword": "Zadejte sem.",
  "providerIntro.step3KeyOrToken": "Vložte sem.",
  "providerIntro.step3OAuth": "Autorizujte SmartMixin ve vyskakovacím okně.",
  "providerIntro.step3Wunderground": "Vložte svůj API klíč a poté vyberte stanici v blízkosti nebo zadejte libovolné ID stanice.",
  "providerIntro.title": "Připojit {provider}",
  "providerIntro.weatherflowStep2": "Získejte svůj osobní Tempest token.",
  "providerIntro.wundergroundBrowsePublic": "Nemáte stanici? Procházejte veřejné",
  "providerIntro.wundergroundFindNearby": "Najít stanice v okolí",
  "providerIntro.wundergroundOrEnterId": "Nebo zadat ID stanice",
  "providerIntro.wundergroundStep2": "Získejte svůj API klíč Weather Underground. Poté budete moci připojit jakoukoli stanici — vlastní nebo veřejnou.",
  "reports.agroMeteorology": "Agrometeorologie",
  "reports.analysis": "Analýza",
  "reports.annualCumulativeRainfallComparison": "Porovnání ročních úhrnů srážek",
  "reports.annualHeatingDurationComparison": "Roční srovnání doby vytápění",
  "reports.annualHeatingEfficiency": "Roční srovnání - účinnost vytápění",
  "reports.annualIndoorComparison": "Roční srovnání - uvnitř",
  "reports.annualIndoorReport": "Výroční vnitřní zpráva",
  "reports.annualOutdoorComparison": "Roční porovnání - venku",
  "reports.annualOutdoorReport": "Roční souhrn - venku",
  "reports.annualReport": "Roční report",
  "reports.annualSolarReport": "Roční solární zpráva",
  "reports.annualWaterBalance": "Roční vodní bilance",
  "reports.annualWaterBalanceCarryOver": "Převést z předchozího roku",
  "reports.annualWaterBalanceDescription": "Vodní bilance (zjednodušená verze, používá se pouze déšť a evapotranspirace) umožňuje hospodaření s vodními zdroji",
  "reports.avgHumidity": "Průměrná vlhkost",
  "reports.avgMaxTemperature": "Průměrné teplotní maximum",
  "reports.avgMetric": "Průměr – {metric}",
  "reports.avgMinTemperature": "Průměrné teplotní minimum",
  "reports.avgPressure": "Průměrný tlak",
  "reports.avgTemperature": "Průměrná teplota",
  "reports.climateNormalPeriodOfRecord": "Období měření ({years, plural, one {# rok} few {# roky} many {# roku} other {# let}})",
  "reports.climateNormals": "Klimatické normály",
  "reports.climateNormalStandardLabel": "Standardní normál ({period})",
  "reports.climateTrendPerDecade": "Trend teploty: {value} za desetiletí během {years, plural, one {# roku} few {# let} many {# let} other {# let}}",
  "reports.coldestMonthRanking": "Nejchladnější {month} v historii měření",
  "reports.comfortable": "Komfortní (45% {lessThan} vlhkost ≤ 60%)",
  "reports.cumulativeRainfall": "Kumulativní srážky",
  "reports.cumulativeRainfallDescription": "Sledujte celkový úhrn srážek nahromaděných za zvolené období.",
  "reports.dailyMaxRainfall": "Max. denní srážky",
  "reports.dataExport": "Export dat",
  "reports.dataExportXlsxFormatDescription": "Exportujte všechna data stanice ve formátu aplikace Excel (* .xlsx). Jakmile kliknete na tlačítko, obdržíte e-mail s zpracovanými daty po několika minutách.",
  "reports.daysOfData": "{days, plural, one {# den} few {# dny} many {# dne} other {# dní}} dat",
  "reports.daysWithFrost": "Mrazových dní",
  "reports.daysWithHeavyRain": "Dny s vydatným deštěm (≥ {threshold})",
  "reports.daysWithoutThaw": "Ledových dní",
  "reports.daysWithStrongFrost": "Dní se silným mrazem",
  "reports.emailSent": "Byla vám zaslána e-mailová zpráva",
  "reports.frostDays": "Mrazové dny",
  "reports.grasslandTemperatureSum": "Součet teplot travních porostů",
  "reports.grasslandTemperatureSumDescription": "Udržitelná obnova vegetace, když součet dosáhne {threshold}",
  "reports.growingDegreeDays": "Růstové stupňodny",
  "reports.highPressure": "Tlaková výše (Průměrný tlak ≥ 1013 mbar)",
  "reports.iceDays": "Ledové dny",
  "reports.indoorReport": "Vnitřní hlášení",
  "reports.keyFacts": "Hlavní fakta",
  "reports.longestDrySpell": "Nejdelší bezsrážkové období",
  "reports.longestRunOfRainyDays": "Počet po sobě jdoucích deštivých dnů",
  "reports.longestRunWithoutRun": "Počet po sobě jdoucích dnů bez deště",
  "reports.longestWetSpell": "Nejdelší období srážek",
  "reports.lowPressure": "Tlaková níže (Průměrný tlak {lessThan} 1013 mbar)",
  "reports.maxHumidity": "Maximální vlhkost",
  "reports.maxMetric": "Maximum – {metric}",
  "reports.maxPressure": "Maximální tlak",
  "reports.maxPressureMagnitude24h": "Maximální změna za 24h",
  "reports.maxTemperature": "Maximální teplota",
  "reports.maxTempGreaterThan": "T°max ≥",
  "reports.maxTempMagnitude24h": "Maximální změna za 24h",
  "reports.minHumidity": "Minimální vlhkost",
  "reports.minMetric": "Minimum – {metric}",
  "reports.minPressure": "Minimální tlak",
  "reports.minPressureMagnitude24h": "Minimální změna za 24h",
  "reports.minTemperature": "Minimální teplota",
  "reports.minTempMagnitude24h": "Minimální změna za 24h",
  "reports.monthlyAverageCountdown": "{days, plural, one {Ještě # den} few {Ještě # dny} many {Ještě # dne} other {Ještě # dní}} tento měsíc",
  "reports.monthlyAverageCountdownDetail": "Poté se zobrazí průměr tohoto měsíce a jeho pořadí.",
  "reports.monthlyAverageRule": "Měsíční průměry a pořadí se zobrazí, jakmile kalendářní měsíc má zaznamenáno {days, plural, one {# den} few {# dny} many {# dne} other {# dní}}.",
  "reports.monthlyHeatingEfficiency": "Měsíční souhrn - účinnost vytápění",
  "reports.monthlyIndoorReport": "Měsíční souhrn - uvnitř",
  "reports.monthlyOutdoorReport": "Měsíční souhrn - venku",
  "reports.monthlyReport": "Měsíční report",
  "reports.monthlySolarReport": "Měsíční solární zpráva",
  "reports.monthlyWindReport": "Měsíční souhrn - vítr",
  "reports.monthsOfData": "{months, plural, one {# měsíc} few {# měsíce} many {# měsíce} other {# měsíců}} dat",
  "reports.numberOfDays": "Počet dní",
  "reports.onThisDayInHistory": "Tento den v historii",
  "reports.outdoorReport": "Outdoor report",
  "reports.overviewSection": "Přehled",
  "reports.rainfall": "Srážky",
  "reports.rainyDays": "Deštivých dní",
  "reports.recordDailyRain": "Nejdeštivější den",
  "reports.recordHigh": "Rekordní maximum",
  "reports.recordLow": "Rekordní minimum",
  "reports.recordsAndClimatology": "Rekordy a klima",
  "reports.recordsSince": "Rekordy od {date}",
  "reports.recordWindGust": "Nejsilnější poryv větru",
  "reports.relativelyWet": "Nadměrně vlhké (60% {lessThan} vlhkost ≤ 80%)",
  "reports.sectionReportCount": "{count, plural, one {# zpráva} few {# zprávy} many {# zpráv} other {# zpráv}}",
  "reports.sendEmail": "Odeslat e-mail",
  "reports.summerDays": "Letní dny",
  "reports.tooDry": "Velmi suché (vlhkost ≤ 45%)",
  "reports.tooWet": "Velmi vlhké (vlhkost {greaterThan} 80%)",
  "reports.tropicalNights": "Tropických nocí",
  "reports.unlockPremiumSubtitle": "Součástí SmartMixin Premium",
  "reports.unlockPremiumTitle": "Odemkněte {count, plural, one {# prémiovou funkci} few {# prémiové funkce} many {# prémiových funkcí} other {# prémiových funkcí}}",
  "reports.warmestMonthRanking": "Nejteplejší {month} v historii měření",
  "reports.waterBalance": "Vodní bilance",
  "reports.yearsOfData": "{years, plural, one {# rok} few {# roky} many {# roku} other {# let}} dat",
  "reports.yearToDateTemperatureComparison": "Srovnání teplot od začátku roku",
  "sensors.aqiByChannel": "AQI podle kanálu",
  "sensors.bgtSensors": "Černý globus a WBGT",
  "sensors.cameraFeed": "Kamera",
  "sensors.compareAqi": "Porovnat AQI",
  "sensors.compareHumidity": "Porovnat vlhkost",
  "sensors.compareMoisture": "Porovnat půdní vlhkost",
  "sensors.comparePm25": "Porovnat PM2.5",
  "sensors.compareTemperatures": "Porovnat teploty",
  "sensors.depthByChannel": "Hloubka podle kanálu",
  "sensors.heatStressExtreme": "Extrémní tepelný stres",
  "sensors.heatStressModerate": "Mírný tepelný stres",
  "sensors.heatStressNone": "Žádný tepelný stres",
  "sensors.heatStressStrong": "Silný tepelný stres",
  "sensors.heatStressVeryStrong": "Velmi silný tepelný stres",
  "sensors.humidityByChannel": "Vlhkost podle kanálu",
  "sensors.indoorAirQualityPm": "PM2.5 a PM10 AQI",
  "sensors.indoorClimate": "Vnitřní klima",
  "sensors.indoorCo2Levels": "Úrovně CO2",
  "sensors.indoorTemperatureAndHumidity": "Teplota a vlhkost",
  "sensors.last24Hours": "24 hodin",
  "sensors.last30Days": "30 dní",
  "sensors.last7Days": "7 dní",
  "sensors.leafTemperatureByChannel": "Teplota listů podle kanálu",
  "sensors.leafWetnessByChannel": "Vlhkost listů podle kanálu",
  "sensors.lightningSensor": "Blesk",
  "sensors.moistureByChannel": "Půdní vlhkost podle kanálu",
  "sensors.noDataAvailable": "Žádná data nejsou k dispozici",
  "sensors.pm10AndAqi": "PM10 & AQI",
  "sensors.pm1AndAqi": "PM1.0 & AQI",
  "sensors.pm25AndAqi": "PM2.5 & AQI",
  "sensors.pm25ByChannel": "PM2.5 podle kanálu",
  "sensors.pm4AndAqi": "PM4.0 & AQI",
  "sensors.selectChannel": "Vyberte kanál",
  "sensors.sensorDetailDescription": "Zobrazení historických dat a trendů pro kanály senzoru.",
  "sensors.sensorHistory": "Historie senzoru",
  "sensors.soilConductivityByChannel": "Vodivost podle kanálu",
  "sensors.soilTemperatureByChannel": "Teplota půdy podle kanálu",
  "sensors.strikesToday": "Údery dnes",
  "sensors.temperatureByChannel": "Teplota podle kanálu",
  "sensors.viewChart": "Zobrazit graf",
  "settings.about": "O aplikaci",
  "settings.aboutDescription": "Licenční smlouva, zásady ochrany osobních údajů",
  "settings.account": "Účet",
  "settings.accountDescription": "Profil, změna hesla",
  "settings.accountIntro": "Údaje se týkají vašeho účtu:",
  "settings.accountOnHoldTitle": "Účet pozastaven",
  "settings.accountSection": "Účet",
  "settings.addForecastModel": "Přidat model",
  "settings.appearance": "Vzhled",
  "settings.appearanceDescription": "Motiv a možnosti zobrazení",
  "settings.appVersion": "SmartMixin v{version}",
  "settings.arabic": "arabština",
  "settings.atYourStations": "Dostupné na vašich stanicích",
  "settings.availableServices": "Dostupné",
  "settings.bulgarian": "bulharský",
  "settings.cannotDisconnectLastAccount": "Nelze odpojit jedinou metodu přihlášení. Nejprve přidejte jinou metodu přihlášení.",
  "settings.catalan": "katalánština",
  "settings.changeEmail": "Změnit e-mail",
  "settings.changePassword": "Změna hesla",
  "settings.chartGestures": "Gesta v grafech",
  "settings.chartGesturesDescription": "Přejetím po grafech změníte časové období, stažením grafů změníte časové měřítko",
  "settings.choiceCount": "{count, plural, one {Dostupný: #} few {Dostupné: #} many {Dostupných: #} other {Dostupných: #}}",
  "settings.connect": "Připojit",
  "settings.connected": "Připojeno",
  "settings.connectedAccounts": "Propojené účty",
  "settings.connectedAccountsDescription": "Apple, Google, Facebook",
  "settings.connectedServices": "Připojeno",
  "settings.connectedSince": "Připojeno od {date}",
  "settings.connectionSection": "Připojení",
  "settings.connectionSuccess": "Účet {provider} úspěšně připojen",
  "settings.contactUs": "Kontaktujte nás",
  "settings.contactUsDescription": "Získejte pomoc nebo pošlete zpětnou vazbu",
  "settings.coverageLoading": "Zjišťujeme, které z vašich stanic každý model pokrývá…",
  "settings.croatian": "chorvatský",
  "settings.currentPassword": "Aktuální heslo",
  "settings.czech": "česky",
  "settings.dailyDetailByPeriods": "Denní detail po částech dne",
  "settings.dailyDetailByPeriodsDescription": "Seskupí 24 hodin do noci, rána, odpoledne a večera — stejné rozdělení, jaké používá souhrn dne.",
  "settings.dangerZone": "Riziková zóna",
  "settings.danish": "dánština",
  "settings.dark": "Tmavý motiv",
  "settings.dataDisplay": "Zobrazení dat",
  "settings.dateAndTime": "Datum a hodina",
  "settings.disconnect": "Odpojit",
  "settings.disconnectConfirmation": "Opravdu chcete odpojit svůj účet {provider}?",
  "settings.disconnectionSuccess": "Účet {provider} úspěšně odpojen",
  "settings.disconnectProviderDescription": "Zastaví synchronizaci. Vaše historie zůstane zachována.",
  "settings.donateButton": "Přispět darem",
  "settings.donateDescription": "SmartMixin vytváří malý tým. Pokud je pro vás užitečný, můžete podpořit jeho vývoj jednorázovým darem v libovolné výši. Je to dar — nemění váš tarif ani neodemyká žádné funkce.",
  "settings.donateSuccessBody": "Váš dar pomáhá udržet SmartMixin v provozu a zlepšovat ho. Velmi si toho vážíme.",
  "settings.donateSuccessTitle": "Děkujeme za vaši podporu!",
  "settings.donateTitle": "Podpořte SmartMixin",
  "settings.dragToReorder": "Přetažením změníte pořadí",
  "settings.dutch": "holandština",
  "settings.emailChange": "Změnit e-mailovou adresu",
  "settings.emailChangeConfirmation": "Potvrzení změny e-mailu",
  "settings.emailChangeFailure": "Odkaz pro změnu e-mailu je neplatný nebo vypršel.",
  "settings.emailChangeSuccess": "Váš e-mail byl úspěšně změněn na {newEmail}.",
  "settings.emailChangeVerificationSent": "Na vaši novou e-mailovou adresu byl odeslán ověřovací e-mail. Zkontrolujte svou doručenou poštu a klikněte na odkaz pro potvrzení změny.",
  "settings.english": "angličtina",
  "settings.everywhereElse": "Všude jinde",
  "settings.everywhereElseFoot": "Použije se na každé stanici, kam vaše preferované modely nedosáhnou.",
  "settings.everywhereElsePick": "Vyberte jeden",
  "settings.fallbackBlend": "Směs SmartMixin",
  "settings.fallbackBlendSub": "Kombinuje několik modelů, každý tam, kde je nejsilnější.",
  "settings.fallbackEcmwf": "ECMWF",
  "settings.fallbackEcmwfSub": "ECMWF HRES všude, kam dosáhne.",
  "settings.fallbackGfs": "GFS",
  "settings.fallbackGfsSub": "Globální model NOAA. To, co dnes používá každý účet.",
  "settings.fallbackResolution": "Nejvyšší rozlišení",
  "settings.fallbackResolutionSub": "Nejjemnější síť dostupná na každé stanici.",
  "settings.forecastModels": "Modely předpovědi",
  "settings.freeBannerBody": "Bezplatné účty dostávají všude GFS — preferované modely i „všude jinde“ začnou fungovat ve chvíli, kdy si předplatíte.",
  "settings.freeBannerTitle": "Předvolby platí s Premium",
  "settings.french": "francouzsky",
  "settings.german": "německy",
  "settings.gestures": "Gesta",
  "settings.greek": "řecký",
  "settings.helpCenter": "Centrum nápovědy",
  "settings.helpCenterDescription": "Často kladené otázky a návody",
  "settings.hungarian": "maďarština",
  "settings.integrationsSection": "Integrace",
  "settings.italian": "italština",
  "settings.japanese": "japonský",
  "settings.korean": "korejština",
  "settings.language": "Jazyk",
  "settings.languageDescription": "Preferovaný jazyk",
  "settings.light": "Světlý motiv",
  "settings.measurementUnits": "Měrné jednotky",
  "settings.netatmoDashboard": "Přehled Netatmo",
  "settings.netatmoLayoutCards": "Seznam karet",
  "settings.netatmoLayoutCardsDescription": "Jedna karta na modul, vše v jednom rolování",
  "settings.netatmoLayoutClassic": "Klasické",
  "settings.netatmoLayoutClassicDescription": "Dvě karty, přepínání mezi moduly",
  "settings.netatmoNewLayoutNotice": "Nové rozvržení přehledu: jedna karta na modul.",
  "settings.netatmoSwitchBackToClassic": "Zpět na klasické",
  "settings.netatmoSwitchToLayout": "Přepnout na {layout}",
  "settings.newEmailAddress": "Nová e-mailová adresa",
  "settings.newPassword": "Nové heslo",
  "settings.newPasswordAgain": "Nové heslo (podruhé)",
  "settings.norwegian": "norský",
  "settings.notConnected": "Nepřipojeno",
  "settings.notificationsSection": "Oznámení",
  "settings.oldPassword": "Staré heslo",
  "settings.ongoingNotificationEnabled": "Povolit trvalé oznámení",
  "settings.ongoingNotificationMetrics": "Zobrazené metriky",
  "settings.ongoingNotificationPermissionRequired": "Je vyžadováno oprávnění k oznámením",
  "settings.ongoingNotificationPreviewHint": "Náhled — zapněte widget, aby se zobrazil",
  "settings.ongoingNotificationStation": "Meteorologická stanice",
  "settings.ongoingNotificationStatusBar": "Stavový řádek",
  "settings.passwordChange": "Změna hesla",
  "settings.passwordChangeDescription": "Udržujte svůj účet v bezpečí",
  "settings.pickerShowAll": "Zobrazit celý katalog",
  "settings.pickerUnreachable": "{count, plural, one {# další model nedosáhne} few {# další modely nedosáhnou} many {# dalších modelů nedosáhne} other {# dalších modelů nedosáhne}} na žádnou z vašich stanic",
  "settings.pinInUse": "Používá se",
  "settings.pinShadowed": "Nikdy se nepoužije — model výše pokrývá všechny vaše stanice",
  "settings.pinSlots": "{used} z {max} · klepnutím vyberte",
  "settings.pinSlotsFull": "Všechna {max} místa jsou obsazená. Jedno odeberte, abyste mohli přidat další.",
  "settings.pinsUncoveredCount": "{used} z vašich {count, plural, one {# stanice} few {# stanic} many {# stanic} other {# stanic}}: nedosáhne na ně žádný preferovaný model — rozhoduje „všude jinde“.",
  "settings.pinsUncoveredNamed": "{stations}: nedosáhne {count, plural, one {na ni} other {na ně}} žádný preferovaný model — rozhoduje „všude jinde“.",
  "settings.pinUnreachable": "Nikdy se nepoužije — nedosáhne na žádnou z vašich stanic",
  "settings.pinUsedAt": "Používá se na {stations}",
  "settings.pinUsedAtAll": "{count, plural, one {Používá se na vaší stanici} few {Používá se na všech # stanicích} many {Používá se na všech # stanicích} other {Používá se na všech # stanicích}}",
  "settings.pinUsedAtSome": "Používá se na {used} z {count, plural, one {# stanice} few {# stanic} many {# stanic} other {# stanic}}",
  "settings.polish": "polsky",
  "settings.portuguese": "portugalština",
  "settings.preferencesSection": "Předvolby",
  "settings.preferredModels": "Preferované modely",
  "settings.preferredModelsAll": "Jeden seznam, všechny stanice",
  "settings.preferredModelsOne": "Jeden seznam, platí všude",
  "settings.premium": "Premium",
  "settings.premiumActive": "Aktivní",
  "settings.premiumAnnualThenPrice": "Poté 9,99 €/rok",
  "settings.premiumAnnualTrialInfo": "Začněte s bezplatnou zkušební dobou na {days} dní",
  "settings.premiumCurrentPlan": "Aktuální plán",
  "settings.premiumDescription": "Odemknout prémiové funkce",
  "settings.premiumDownloadApp": "Stáhněte aplikaci pro předplatné:",
  "settings.premiumExpiresOn": "Obnovuje se {date}",
  "settings.premiumFreePlan": "Zdarma",
  "settings.premiumInactive": "Bez předplatného",
  "settings.premiumManageWebSubscription": "Spravujte své předplatné, aktualizujte platební metodu nebo zrušte.",
  "settings.premiumPremiumPlan": "Premium",
  "settings.premiumSubscribeAnnual": "Ročně — 9,99 €/rok",
  "settings.premiumSubscribedOn": "Předplaceno přes {platform}",
  "settings.premiumSubscribeMonthly": "Měsíčně — 1,99 €/měsíc",
  "settings.premiumSubscribeOnWeb": "Přihlaste se k odběru a odemkněte všechny prémiové funkce.",
  "settings.premiumSubscriptionSuccess": "Vaše předplatné bylo aktivováno! Užijte si všechny prémiové funkce.",
  "settings.premiumSubscriptionSuccessTitle": "Vítejte v Premium!",
  "settings.premiumWebappNotice": "Předplatné lze zakoupit pouze prostřednictvím mobilní aplikace SmartMixin pro iOS nebo Android.",
  "settings.privacyPolicy": "Zásady ochrany osobních údajů",
  "settings.profile": "Profil uživatele",
  "settings.removePreferredModel": "Odebrat {model} z preferovaných modelů",
  "settings.resetForecastPreference": "Obnovit výchozí",
  "settings.resetForecastPreferenceHint": "Vymaže preferované modely a vrátí výchozí nastavení SmartMixin.",
  "settings.russian": "ruština",
  "settings.seePremium": "Zobrazit Premium",
  "settings.serbian": "srbština",
  "settings.servedNowMany": "Právě teď: GFS {count, plural, one {na vaší stanici} few {na všech # stanicích} many {na všech # stanicích} other {na všech # stanicích}}.",
  "settings.servedNowNone": "Právě teď: GFS všude.",
  "settings.settings": "Nastavení",
  "settings.signedInAs": "Přihlášen jako",
  "settings.slovak": "slovák",
  "settings.smallDecimals": "Malé desetinné",
  "settings.smallDecimalsDescription": "Zobrazit desetinné číslice v menší velikosti",
  "settings.socialConnectionsIntro": "Propojte své sociální účty pro rychlé přihlášení. Účty můžete kdykoliv připojit nebo odpojit.",
  "settings.spanish": "španělština",
  "settings.statusBarWidget": "Widget stavového řádku",
  "settings.statusBarWidgetDescription": "Vždy viditelná data o počasí",
  "settings.subscriptionSection": "Předplatné",
  "settings.supportSection": "Podpora",
  "settings.swedish": "švédština",
  "settings.systemTheme": "Téma systému",
  "settings.termsOfService": "Podmínky služby",
  "settings.turkish": "turečtina",
  "settings.ukrainian": "ukrajinština",
  "settings.units": "Jednotky",
  "settings.unitsDescription": "Jednotky měření zobrazené v aplikaci",
  "settings.update": "Aktualizovat",
  "settings.updateYourProfile": "Aktualizujte svůj profil",
  "settings.updateYourProfileDescription": "Jméno a předvolby zobrazení",
  "settings.weatherServices": "Meteorologické služby",
  "settings.weatherServicesConnected": "{count, plural, =0 {Žádné připojené služby} one {# připojená služba} few {# připojené služby} many {# připojené služby} other {# připojených služeb}}",
  "settings.weatherServicesDescription": "Připojte Netatmo, Davis, Weatherflow a další",
  "settings.windDirectionConvention": "Šipka směru větru",
  "settings.windDirectionConventionDescription": "Vyberte způsob zobrazení šipek směru větru",
  "settings.windDirectionMeteorological": "Směr původu",
  "settings.windDirectionMeteorologicalDescription": "Šipka ukazuje, odkud vítr fouká (meteorologická konvence)",
  "settings.windDirectionOceanographic": "Směr proudění",
  "settings.windDirectionOceanographicDescription": "Šipka ukazuje, kam vítr fouká (oceánografická konvence)",
  "units.absolutePressure": "Absolutní tlak",
  "units.airDensity": "Hustota vzduchu",
  "units.airGap": "Vzduchová mezera",
  "units.apparentTemperature": "Zdánlivá teplota",
  "units.AQI": "AQI",
  "units.AQI_24H": "24h AQI",
  "units.avg": "Prům.",
  "units.avg_wind": "Průměrný vítr",
  "units.beaufort": "Beaufort",
  "units.blackGlobeTemperature": "Teplota černého globu",
  "units.boilerOn": "Ohřev zapnutý",
  "units.co2": "CO2",
  "units.conductivity": "Vodivost",
  "units.coolingDegreeDays": "Chladné denostupně",
  "units.dailyHeatingDuration": "Denní doba ohřevu",
  "units.dailyPrecipitation": "Denní srážky",
  "units.dailyRain": "Denní déšť",
  "units.degreeDay": "Stupeň-den",
  "units.degreeDayShort": "DJU",
  "units.depth": "Hloubka",
  "units.depthSensors": "Senzory hloubky",
  "units.dewPoint": "Rosný bod",
  "units.distance": "Vzdálenost",
  "units.downTrend": "Sestupný trend",
  "units.E": "V",
  "units.E_long": "Východní",
  "units.ENE": "VSV",
  "units.ENE_long": "východ-severovýchod",
  "units.ESE": "VJV",
  "units.ESE_long": "východ-jihovýchod",
  "units.ET": "Evapotranspirace",
  "units.ETshort": "A",
  "units.feelLike": "Pocit jako",
  "units.feelsLike": "Pocit jako",
  "units.footMile": "noha, míle",
  "units.frostPoint": "bod mrazu",
  "units.gust": "Náraz",
  "units.heatIndex": "Tepelný index",
  "units.heatingDegreeDays": "Denní stupně vytápění",
  "units.heatingPower": "Topný výkon",
  "units.humidex": "Humidex",
  "units.humidity": "Vlhkost",
  "units.inch": "Palec",
  "units.inchOfMercury": "Palce rtuti",
  "units.kilometerPerHour": "Kilometr za hodinu",
  "units.knot": "Knot",
  "units.last12Hours": "Posledních 12 hodin",
  "units.last24Hours": "Posledních 24 hodin",
  "units.last3Hours": "Poslední 3 hodiny",
  "units.last6Hours": "Posledních 6 hodin",
  "units.lastHour": "Poslední hodina",
  "units.lastLightningImpact": "Poslední úder blesku",
  "units.lastMeasure": "Poslední měření",
  "units.leafSensors": "Senzory listů",
  "units.leafWetness": "Vlhkost listů",
  "units.lightningDistance": "Vzdálenost",
  "units.lightningStrikeCount": "Počet úderů blesku",
  "units.lightningStrikeDistance": "Vzdálenost úderu blesku",
  "units.max": "Max.",
  "units.max_gust": "Max. náraz",
  "units.maxToday": "Max. dnes",
  "units.meterKilometer": "metr, kilometr",
  "units.meterPerSecond": "Meter za sekundu",
  "units.milePerHour": "Míle za hodinu",
  "units.millibar": "Millibar",
  "units.millimeter": "Milimetr",
  "units.millimeterOfMercury": "Milimetr rtuti",
  "units.min": "Min.",
  "units.N": "S",
  "units.N_long": "severní",
  "units.NE": "SV",
  "units.NE_long": "severovýchod",
  "units.NNE": "SSV",
  "units.NNE_long": "severo-severovýchod",
  "units.NNW": "SSZ",
  "units.NNW_long": "severo-severozápad",
  "units.noise": "Hluk",
  "units.normalizedHeatingCoefficient": "Normalizovaný topný koeficient",
  "units.NW": "SZ",
  "units.NW_long": "Severozápad",
  "units.O3": "Ozón",
  "units.PM_1": "PM 1",
  "units.PM_10": "PM 10",
  "units.PM_2P5": "PM 2.5",
  "units.precipitation": "Srážky",
  "units.pressure": "Tlak",
  "units.rain": "Srážky",
  "units.rainRate": "Intenzita deště",
  "units.referenceTemperature": "Referenční teplota",
  "units.relativePressure": "Relativní tlak",
  "units.S": "J",
  "units.S_long": "jižní",
  "units.SE": "JV",
  "units.SE_long": "jihovýchodní",
  "units.setPoint": "Nastavit",
  "units.snow": "Sníh",
  "units.snowfall": "Sněžení",
  "units.soilMoisture": "Půdní vlhkost",
  "units.soilSensors": "Podlahové senzory",
  "units.solarEnergy": "Solární energie",
  "units.solarRadiation": "Solární radiace",
  "units.speed": "Rychlost",
  "units.SSE": "JJV",
  "units.SSE_long": "jiho-jihovýchodní",
  "units.SSW": "JJZ",
  "units.SSW_long": "jiho-jihozápad",
  "units.stableTrend": "Stabilní trend",
  "units.sum": "Sum",
  "units.SW": "JZ",
  "units.SW_long": "jihozápad",
  "units.temperature": "Teplota",
  "units.temperatureAndHumiditySensors": "Senzory teploty/vlhkosti",
  "units.temperatureSensors": "Senzory teploty/vlhkosti",
  "units.thsw": "THSW",
  "units.thw": "THW",
  "units.today": "Dnes",
  "units.upTrend": "Vzestupný trend",
  "units.uv": "UV",
  "units.visibility": "Viditelnost",
  "units.W": "Z",
  "units.W_long": "Západ",
  "units.wetBulbGlobeTemperature": "Temp. mokrá žárovka",
  "units.wetBulbTemperature": "Temp. mokrá žárovka",
  "units.wind": "Vítr",
  "units.windChill": "Wind Chill",
  "units.windDirection": "Směr větru",
  "units.windRun": "průběh větru",
  "units.windRunDescription": "Cesta větrem je celková vzdálenost, kterou vítr urazí za určité časové období",
  "units.WNW": "ZSZ",
  "units.WNW_long": "západ-severozápad",
  "units.WSW": "ZJZ",
  "units.WSW_long": "západ-jihozápad",
  "weatherConditions.blizzard": "Sněhová vánice",
  "weatherConditions.blowingDust": "Zvířený prach",
  "weatherConditions.blowingSnow": "Zvířený sníh",
  "weatherConditions.breezy": "Mírný vítr",
  "weatherConditions.clear": "Jasno",
  "weatherConditions.cloudy": "Zataženo",
  "weatherConditions.drizzle": "Mrholení",
  "weatherConditions.flurries": "Slabé sněžení",
  "weatherConditions.foggy": "Mlha",
  "weatherConditions.freezingDrizzle": "Mrznoucí mrholení",
  "weatherConditions.freezingRain": "Mrznoucí déšť",
  "weatherConditions.frigid": "Silný mráz",
  "weatherConditions.hail": "Krupobití",
  "weatherConditions.haze": "Zákal",
  "weatherConditions.heavyRain": "Silný déšť",
  "weatherConditions.heavySnow": "Silné sněžení",
  "weatherConditions.hot": "Horko",
  "weatherConditions.hurricane": "Hurikán",
  "weatherConditions.isolatedThunderstorms": "Ojedinělé bouřky",
  "weatherConditions.mixedRainAndHail": "Déšť s kroupami",
  "weatherConditions.mostlyClear": "Převážně jasno",
  "weatherConditions.mostlyCloudy": "Převážně zataženo",
  "weatherConditions.mostlySunny": "Převážně slunečno",
  "weatherConditions.notAvailable": "Povětrnostní podmínky nejsou k dispozici",
  "weatherConditions.partlyCloudy": "Polojasno",
  "weatherConditions.rain": "Déšť",
  "weatherConditions.rainSleet": "Déšť s ledovými kuličkami",
  "weatherConditions.rainSnow": "Déšť se sněhem",
  "weatherConditions.scatteredShowers": "Rozptýlené přeháňky",
  "weatherConditions.scatteredSnowShowers": "Rozptýlené sněhové přeháňky",
  "weatherConditions.scatteredThunderstorms": "Rozptýlené bouřky",
  "weatherConditions.showers": "Přeháňky",
  "weatherConditions.sleet": "Ledové kuličky",
  "weatherConditions.smoke": "Kouř",
  "weatherConditions.snow": "Sněžení",
  "weatherConditions.snowShowers": "Sněhové přeháňky",
  "weatherConditions.strongStorms": "Silné bouřky",
  "weatherConditions.sunny": "Slunečno",
  "weatherConditions.thunderstorms": "Bouřky",
  "weatherConditions.tornado": "Tornádo",
  "weatherConditions.tropicalStorm": "Tropická bouře",
  "weatherConditions.windy": "Větrno",
  "weatherConditions.wintryMix": "Smíšené zimní srážky"
}
